export default {
  "SpecialData": {
    "ipv4Mask": "Post-route IPv4 Mask",
    "addProfile": "Add Profile",
    "mnc": "MNC",
    "modProfileSuccess": "Profile deleted successfully",
    "addProfileSuccess": "Profile added successfully",
    "qryProfileSuccess": "Profile queried successfully",
    "specialSign": "Personalized Profile",
    "modProfile": "Modify Profile",
    "mcc": "MCC",
    "delProfileSuccess": "Profile deleted successfully",
    "supi": "SUPI",
    "ipTypeNotNull": "Static address type cannot be empty.",
    "ipv6Addr": "Static IPv6 Address",
    "sd": "SD",
    "staticIpForbid": "Static Address Subscription",
    "crumb": "Subscriber/UDM Management/Personalized Management",
    "sst": "SST",
    "staticIpv6Prefix": "Static IPv6 Prefix",
    "dnnName": "APN",
    "ipv4Addr": "Static IPv4 Address",
    "ipv6Prefix": "Post-route IPv6 Prefix",
    "conflict": "Static address type conflict"
  },
  "Pvi": {
    "op": "OP",
    "pvi": "PVI",
    "pviSearch": "Enter PVI to search",
    "addPviSuccess": "PVI added successfully.",
    "qryPviSuccess": "PVI queried successfully.",
    "modPvi": "Modify PVI",
    "delPviSuccess": "PVI deleted successfully.",
    "modPviSuccess": "PVI modified successfully.",
    "crumb": "Subscriber/VoNR Management/PVI Template",
    "addPvi": "ADD PVI",
    "addBatchPvi": "Add PVI in batch",
    "amf": "AMF",
    "ki": "KI"
  },
  "DNN": {
    "ambrUp": "DNN Uplink AMBR(KBPS)",
    "addProfileSuccess": "DNN template added successfully.",
    "qryProfileSuccess": "DNN template queried successfully.",
    "sscMode": "SSC Mode",
    "dnnParamInfo": "DNN Parameters",
    "delProfileSuccess": "DNN template deleted successfully.",
    "pec": "PCI",
    "commonError15": "The number of users reaches the upper limit of the license.",
    "commonError14": "Duplicate ID",
    "lboRoamingAllowed1": "Allowed",
    "dnnName": "APN",
    "pev": "PVI",
    "max16": "At most 16 items.",
    "dftPduSessionType": "Default PDU Session Type",
    "defaultIndicator1": "Default",
    "qosParamInfo": "QoS Parameters",
    "profileId": "DNN Template ID",
    "profileName": "Template Name",
    "dftSscMode": "Default SSC Mode",
    "disabledPec": "Disabled",
    "pduType1": "IPv6",
    "ambrDown": "DNN Downlink AMBR(KBPS)",
    "pduType2": "IPv4v6",
    "pduType0": "IPv4",
    "sscModeParamInfo": "SSC Mode Parameters",
    "defaultIndicator": "Default Indicator",
    "pduType3": "TRUCTURED",
    "pduType4": "ETHERNET",
    "enabled": "Enabled",
    "enabledPec": "Enabled",
    "crumb": "Subscriber/UDM Management/DNN Template",
    "pduSessionType": "PDU Session Type",
    "sscMode2": "SSC_MODE_3",
    "disabled": "Disabled",
    "notDefaultIndicator0": "Non-default",
    "lboRoamingAllowed": "Allow LBO for Roaming",
    "sscMode0": "SSC_MODE_1",
    "chargeChars": "Charging Characteristics",
    "sscMode1": "SSC_MODE_2",
    "fiveQiPriorityLevel": "5QI Priority",
    "max4": "At most 4 items.",
    "modProfileSuccess": "DNN template modified successfully.",
    "fiveQi": "5QI",
    "commonError11": "Cannot delete the PLMN template due to being associated with a subscription profile.",
    "commonError10": "Cannot delete the AM-DATA template due to being associated with a PLMN template.",
    "commonError13": "Request parameter format error.",
    "commonError12": "Cannot delete the subscription profile due to being associated with subscriber.",
    "commonError9": "Cannot delete the S-NSSAI template due to being associated with a PLMN template.",
    "commonError8": "Cannot delete the DNN template due to being associated with an S-NSSAI template.",
    "commonError7": "The number of items selected for batch operation exceeds the limit.",
    "commonError6": "NE internal error",
    "commonError5": "NE internal error",
    "commonError4": "Missing parameters.",
    "commonError3": "Failed to decode request message.",
    "commonError2": "Template already exists.",
    "commonError1": "Template does not exist.",
    "notAllowed": "Disallowed",
    "commonError0": "Succeeded",
    "pl": "ARP",
    "pduSessionParamInfo": "PDU Session Parameters",
    "max1": "Cannot exceed one item."
  },
  "Usersub": {
    "profileName": "Profile Name",
    "plmnProfileIds": "Associated PLMN Template",
    "addProfile": "Add Subscription Profile",
    "modProfileSuccess": "Subscription profile modified successfully.",
    "addProfileSuccess": "Subscription profile added successfully.",
    "qryProfileSuccess": "Subscription profile queried successfully.",
    "modProfile": "Modify Subscription Profile",
    "plmnInfos": "PLMN",
    "delProfileSuccess": "Subscription profile deleted successfully.",
    "crumb": "Subscriber/UDM Management/Subscription Profile",
    "profileId": "Subscription Profile ID",
    "plmnProfileName": "PLMN Template Name",
    "plmnProfileId": "Associated PLMN Template ID"
  },
  "SubscriberIms": {
    "cancel": "Cancel",
    "userInfo": "Subscriber Info",
    "impFileTypeErrTip": "The imported data format is incorrect.",
    "notModRootTip": "Cannot modify the root node.",
    "mod": "Modify",
    "batchAddUserTip": "Mass Create",
    "del": "Delete",
    "serviceProfileInfoDiv": "Service Profile",
    "chooseUserDataTip": "Select the subscriber data.",
    "userTemplate": "Subscriber Template",
    "zoneTip": "Zone number should be between 328–806.",
    "logTitle": "Log",
    "maxlen15": "No more than 15 characters",
    "unitCode": "Unit Code",
    "rtttype2": "Dispatch",
    "profession": "Job Title",
    "exportdata": "Export",
    "substatus2": "Killed",
    "selectVButton": "Select",
    "rtttype8": "Unified Location Provider",
    "preDelChildNode": "Delete the child node first.",
    "checkDataMoreTip": "Select only one item.",
    "rtttype6": "Broadband Terminal",
    "modUserMember": "Modify Group Member",
    "checkDateLessTip": "Select multiple items.",
    "rtttype4": "Dual-mode Terminal",
    "rtttype5": "Audio/Video Recording Server",
    "temptype": "Template Type",
    "activetime": "Activation Time",
    "groupName": "Group Name",
    "temTitle": "Subscriber/IMS Management/Template Management",
    "notFitDialPlan": "The group number do not meet the numbering plan.",
    "deleteUser": "Delete",
    "grpNumTitle": "*Group Number: Subject to numbering plan",
    "dyGroupNotConfigLSGX": "Dynamic group does not support membership configuration.",
    "regstatus": "Registration Status",
    "noZoneDial6Tip": "000–999",
    "menuTitleUserMcs": "Subscriber/MCS Management/Subscriber Management",
    "supplementaryInfoDiv": "Additional Information",
    "noOperatRole": "Not authorized to operate this node.",
    "template": "Template",
    "notDelRootNode": "Cannot delete the root node.",
    "grpnumrange": "The input should be between 1–99999999.",
    "fuzzyQryNotApplSort": "Fuzzy search does not support sorting.",
    "noZoneDial1Tip": "900–999",
    "search": "Search",
    "regstatus1": "Registered",
    "regstatus0": "Unregistered",
    "requestResTip": "Request failed.",
    "impugrpclass": "In-group Permissions",
    "staffName": "Staff Name",
    "solid_5": "5 digits are allowed.",
    "impuinfoDiv": "Subscriber Information",
    "userNumTitle": "*Subscriber Number: Subject to numbering plan",
    "substatus1": "Stunned",
    "addGroup": "Create",
    "close": "Close",
    "substatus0": "Activate",
    "createtime": "Creation Time",
    "reminder": "Reminder",
    "tempname": "Template Name",
    "qryDialPlanFailTip": "Failed to query the numbering plan.",
    "solid_3": "3 digits are allowed.",
    "batchModUserTip": "Mass Modify",
    "menuTitle": "Subscriber/IMS Management/Group Management",
    "batchModUser": "Mass Modify",
    "notAddNetgate": "Gateway subscribers cannot be added to group.",
    "lsgxInfo": "Configure Membership",
    "batchModGroup": "Mass Modify",
    "loadingvpn": "Loading organization…",
    "numTip": "The subscriber number should be between 00001–29999 or 30019–32767.",
    "invalideChar": "Invalid special characters.",
    "waitTip": "Please wait...",
    "notSuppoDialTip": "The current numbering plan is not supported.",
    "confirm": "OK",
    "endNOLessStartNo": "The end number should be greater than the start number.",
    "noZoneDial4Tip": "00000–99999",
    "insertStaffName": "Enter a staff name.",
    "qryUserMember": "Query Group Member",
    "notModWithDifTypeTip": "Cannot modify subscribers of different types.",
    "insertName": "Enter a name.",
    "organization": "Organization",
    "importdata": "Batch Import",
    "qryVpnFailTip": "Failed to query the organization.",
    "operObj": "Operation Object",
    "menuTitleUser": "Subscriber/IMS Management/Subscriber Management",
    "register": "Registered",
    "infoTitle": "Subscriber/IMS Management/Staff Information",
    "addSiblingNode": "Add Peer Node",
    "addChildNode": "Add Child Node",
    "noDataCanOper": "No operational data found.",
    "noCheckDataTip": "Select an item.",
    "addUser": "Create",
    "use": "Use",
    "groupTemplate": "Group Template",
    "sortBtn": "Sort",
    "chooseNodeTip": "Select an organization node.",
    "batchAddGroup": "Mass Create",
    "post": "Post",
    "find": "Query",
    "grpAttribute": "Group Attribute",
    "checkVpnTip": "Select an organization node.",
    "export": "Export (by search condition)",
    "neList": "NE List",
    "group": "Group",
    "info": "Info",
    "add": "Add",
    "all": "All",
    "notAddDynamicsTip": "Cannot add to a dynamic group.",
    "nelist": "NE List",
    "passwordEqual": "The password and confirm password must be the same.",
    "unitName": "Unit Name",
    "substatus": "Device Status",
    "grptype0": "Normal Group",
    "grpIdentity": "Group Identity",
    "grptype2": "Hybrid Group",
    "licenseNum": "License Plate Number",
    "grptype1": "Roaming Group",
    "grptype4": "Hierarchical Group",
    "grptype3": "Cross-system Group",
    "addGroupMember": "Add to Group",
    "qryGroupMember": "Query Home Group",
    "warn": "Warning",
    "qryDataError": "Device response data error.",
    "tempdate": "Creation Time",
    "staffTitle": "Staff Information",
    "invalidInt": "Invalid integer.",
    "vpnid": "Organization ID",
    "rtttype": "Subscriber Type",
    "userManagement": "IMS Subscriber Management",
    "groupType": "Group Type",
    "addUserMember": "Add Group Member",
    "import": "Batch Import",
    "userNo": "Subscriber Number",
    "grpproperty": "Group Property",
    "tempnum": "Template ID",
    "operResult": "Operation Result",
    "nodesCountTip": "At most six levels of nodes can be added.",
    "hour": "h",
    "delUserMember": "Delete Group Member",
    "batchAddUser": "Mass Create",
    "toomuchUsers": "The number of subscribers created in batch cannot exceed 1000.",
    "grpproperty0": "Static group",
    "clusterGroupCreate": "Create Group",
    "chooseGroupDataTip": "Select the group data.",
    "grpproperty1": "Dynamic group",
    "groupProfileInfoDiv": "Group Profile",
    "resultReturnFailedTip": "Incorrect result. Contact your administrator.",
    "groupNo": "Group Number",
    "tgrpserviceDiv": "Group Profile",
    "noSortVpn": "No nodes need to be sorted.",
    "terType": "Terminal Type",
    "numDialTip9": "200–549",
    "impugrppriority": "In-group Priority",
    "noDialTip": "No numbering plan found.",
    "numDialTip7": "00001–99999",
    "numDialTip8": "200–899",
    "checkZoneTip": "Check the zone number.",
    "numDialTip5": "100–109",
    "numDialTip6": "200–899",
    "mobile": "Mobile",
    "unregister": "Unregistered",
    "deleteConfirm": "Are you sure you want to delete it?",
    "DMRZoneTip": "The zone number in the DMR numbering must be two digits.",
    "dialogListSpan": "Operation finished successfully.",
    "modGroup": "Modify",
    "userName": "Subscriber Name",
    "modifyNode": "Modify Node",
    "minute": "m",
    "qryAdvance": "Advance Search",
    "menuTitleGroupMcs": "Subscriber/MCS Management/Group Management",
    "controlMember": "Group Member Management",
    "operSucess": "Succeeded",
    "modUser": "Modify",
    "numDialTip3": "00001–32767",
    "notChooseRootTip": "Cannot add a peer node to the root node.",
    "clusterUserCreate": "Create Subscriber",
    "numDialTip4": "00001–29999, 30019–32767",
    "numDialTip1": "100–109",
    "numDialTip2": "00000–99999",
    "fresh": "Refresh",
    "user": "Subscriber",
    "subNum": "Subscriber Number",
    "staffId": "Staff ID",
    "templateinfDiv": "Template Information"
  },
  "Index": {
    "help": "Help",
    "exit": "Exit",
    "custom": "Personal Settings",
    "about": "About",
    "pwdFreq": "Change password after {0} minutes.",
    "pwdRepeat": "The new password cannot be the same as the most recent password",
    "myAccount": "My Profile",
    "version": "Version",
    "downloadhelp": "Download Help"
  },
  "Security": {
    "userInfo": "User Info",
    "clientRules": "Address rules",
    "uploadFile": "Upload File",
    "auth": {
      "search": "Search NE",
      "domain": "Domains",
      "ne": "Domain",
      "clusterSearch": "Search",
      "deviceSearch": "Search",
      "fun": "Privileges"
    },
    "addUser": "Add User",
    "deleteLog": "Clicking the confirmation button will delete the database record, and if you don\u0027t want to delete, click the close button.\u003cbr/\u003eBefore deleting database records, check the exported logs.",
    "pwdStrategy": "Password Policy",
    "editUser": "Edit User",
    "userManage": "User Management",
    "loginLog": "Login Log",
    "selectDate": "Select Date",
    "roleNameExists": "Role already exists.",
    "device5G": "Device 5G",
    "unActive": "Deactivate",
    "accountMonitor": "User Monitor",
    "operateCalc": "Operation Statistics",
    "userStrategy": "Account Policy",
    "weekNotNull": "The week cannot be empty.",
    "timeStrategy": "Time Policy",
    "selectTimePolicy": "Select a time policy.",
    "operateLog": "Operation Log",
    "defaultPolicyNotEdit": "Cannot modify the default policy.",
    "group": {
      "groupName": "User Group Name",
      "editGroup": "Edit User Group",
      "name": "User Group",
      "addGroup": "Add User Group"
    },
    "strategyNameExist": "Policy name already exists.",
    "add": "Add",
    "Log": {
      "result": "Result",
      "loginResult": "Login Result",
      "loginTime": "Login Time",
      "feature": "Operation",
      "module": "Module",
      "ip": "IP",
      "resultData": "Result Data",
      "execTime": "Execution Time",
      "execType": "Execution Type"
    },
    "adminGroupCannotModify": "Cannot modify the default user group.",
    "userIPSet": "User IP Settings",
    "active": "Activate",
    "history": "History",
    "inputRoleName": "Enter the role name",
    "authInfo": "Privilege Info",
    "Role": {
      "cluster": "Clusters",
      "creator": "Creator",
      "createTime": "Creation Time",
      "el": "NEs",
      "name": "Role Name",
      "device": "Devices"
    },
    "groupManage": "User Group Management",
    "dateCompare": "The start date cannot be later than the end date.",
    "install": "Install",
    "failure": "Failed",
    "failureMessage": "Duplicate task name.",
    "pwdNotMatch": "Password and confirm password do not match.",
    "success": "Succeeded",
    "forbid": "Forbid",
    "exportTimeNotNull": "Export time cannot be empty.",
    "adminGroupCannotDelete": "Cannot delete the default user group.",
    "copyUser": "Copy User",
    "northGatewayLog": "Northbound Gateway Log",
    "userExist": "User already exists.",
    "device": "Device",
    "addRole": "Add Role",
    "defaultPolicyNotDel": "Cannot delete the default policy.",
    "timeNotNull": "The time cannot not empty.",
    "timeCompare": "The start time cannot be later than the end time.",
    "User": {
      "operateCount": "Operate Count",
      "operateTime": "Operation Time",
      "start": "Enable",
      "confirmpwd": "Confirm Password",
      "realname": "Real Name",
      "password": "Password",
      "expireDay": "Expiry Date",
      "abandon": "Disable",
      "phone": "Phone",
      "operatetime": "Last Operated",
      "lock": "Locked",
      "idletime": "Idle Time(minute)",
      "force": "Force Exit",
      "email": "Email",
      "desc": "Description",
      "username": "User Name",
      "status": "Clear User Status",
      "timeoutstatus": "Timeout Status",
      "inactiveInterval": "Duration Of Inactive Session After Login (Minute)",
      "forbidenDel": "This Super Account cannot be deleted."
    },
    "roleNameNotNull": "Role name cannot be empty.",
    "authorityManage": "User Account",
    "delete": "Delete",
    "roleInfo": "Role Info",
    "editTimePolicy": "Modify Time Policy",
    "client": {
      "addresses": "Binding Addresses",
      "startAddress": "Start Address",
      "addClient": "Add Rule",
      "editClient": "Edit Rule",
      "endAddress": "End Address"
    },
    "placeholder": {
      "strategyName": "Enter the policy name.",
      "password": "Enter the password",
      "inputInteger": "Enter an integer.",
      "mail": "Enter the email.",
      "phone": "Enter the phone number.",
      "startAddress": "Enter the start IP address.",
      "confirmpwd": "Enter the confirm password.",
      "endAddress": "Enter the end IP address.",
      "username": "Enter the user name.",
      "realname": "Enter the real name.",
      "fileName": "Enter the file name.",
      "inactiveInterval": "Enter the duration of inactive session after login (minute)."
    },
    "logManage": "Log Management",
    "editRole": "Modify Role",
    "strategyManage": "Policy Management",
    "securityManage": "Security",
    "validate": {
      "special": "Enter a combination containing at least one special character.",
      "mixedPassword": "Enter a combination of numbers, lowercase letters, uppercase letters, and special characters.",
      "addressCompareErr": "The start IP address should be less than the end iPaddress.",
      "noSpecial": "Enter a combination of numbers, lowercase letters, and uppercase letters.",
      "phone": "Incorrect phone number format.",
      "minLength": "Enter at least {0} characters.",
      "ip": "Incorrect IP address format.",
      "maxLength": "Enter less than {0} characters.",
      "addressRangeErr": "IP address is not in the same segment address.",
      "email": "Enter a valid email address.",
      "ipError": "Incorrect IP address",
      "chooseUser": "Select user",
      "inactiveInterval": "Please enter an integer between 10 and 120"
    },
    "roleManage": "Role Management",
    "selectAccount": "Select user",
    "userGroupInfo": "User Group Info",
    "Lic": {
      "userCount": "Max Number of authorized users",
      "mysqlUserName": "Mysql User Name",
      "nbi": "Northbound interface ",
      "bsCount": "Authorized number of EnodeB",
      "startTime": "Authorization start time",
      "expiredTime": "Authorization end time",
      "curUserCount": "The Current number of logged in users",
      "curBsCount": "The current number of managed EnodeB",
      "voice": "Number of Concurrent Voice Calls",
      "installed": "Installed License",
      "esn": "ESN",
      "unUpload": "Not Uploaded License",
      "maxNumberOfUe": "Number of Accounts Opened",
      "uploadStatus": "Upload Status",
      "installTime": "Install Time",
      "numberOfStation": "Number of EnodeB",
      "caps": "Number of User Sessions",
      "activeLicense_warntip": "The device license has already been activated.",
      "activeLicense_warntip2": "Install the device license first.",
      "uploadStatus_uploaded": "Uploaded",
      "vedio": "Number of Concurrent Video Calls",
      "slice": "Number of Slices",
      "activeLicense_warntip1": "Upload the device license first.",
      "unActiveLicense_warntip1": "Activate the device license first.",
      "sn": "SN",
      "normal": "Normal",
      "activeStatus_activated": "Activated",
      "currentStatus": "Clear Status",
      "activeTime": "Activation Time",
      "loseEfficacy": "Expired",
      "licenseHistoryDetail": "License History",
      "uploadTime": "Upload Time",
      "licenseDetail": "License Details",
      "activeStatus": "Status",
      "activeStatus_inactivated": "Inactivated",
      "activeLicense": "Activate the device license first.",
      "throughPut": "Throughput",
      "installStatus": "Installed",
      "uploadStatus_unupload": "Not Uploaded",
      "syncDevLicense_warntip": "You can only synchronize device for which license is not uploaded."
    },
    "LicenseManage": "License Management",
    "IPRangeSet": "IP Range Settings",
    "EadminCannotDelete": "Cannot delete the Eadmin role.",
    "modify": "Modify",
    "addTimePolicy": "Add Time Policy",
    "device4G": "Device 4G",
    "mysqlUserSettings": "Mysql User Settings",
    "verifyPasswordConsistency": "The password entered twice is inconsistent",
    "passwordVerificationPrompt": "The password requires letters, numbers, uppercase and lowercase letters, and at least 8 characters in length",
    "passwordModifiedSuccessfully": "Password Modified Successfully",
    "passwordModifiedFailed": "Password Modified Failed",
    "dateNotNull": "The date cannot be empty.",
    "Strategy": {
      "date": "Date",
      "accountMinNumber": "Account Minimum Characters",
      "accountInactiveInterval": "Default Duration Of User's Inactive Session After Login (Minute)",
      "accountLoginInterval": "No Login For More Than A Few Days Disable Account (Day)",
      "onlyNumChar": "Contains a combination of numbers, lowercase letters, and uppercase letters",
      "saturday": "Saturday",
      "endDate": "End Date",
      "weekday": "Week",
      "pwdPeriod": "Password Validity Period",
      "lockTime": "Lockout Duration(Minute)",
      "remindDay": "Password Change Notification Before Expiration",
      "friday": "Friday",
      "wednesday": "Wednesday",
      "startTime": "Start Time",
      "monday": "Monday",
      "shortInterval": "Minimum Password Change Interval(Minute)",
      "accountLock": "Account Lock Policy",
      "thursday": "Thursday",
      "failTimes": "Number of Consecutive Login Failures",
      "constitute": "Password Composition",
      "updPwd": "Force password change on expiration",
      "pwdMinNumber": "Password Minimum Characters",
      "pwdHistoryLimit": "Historical passwords cannot be the same for a limited time (Days)",
      "special": "Contains at least one special character:!#$%\u0026*+-/\u003c\u003d\u003e?@[]^{_}~",
      "mixedPassword": "Contains a combination of numbers, lowercase letters, uppercase letters and special characters",
      "sunday": "Sunday",
      "tuesday": "Tuesday",
      "lockPeriod": "Login Duration(Minute)",
      "name": "Policy Name",
      "to": "to",
      "time": "Time",
      "endTime": "Stop Time",
      "updTipInfo": "Changes take effect upon next login.",
      "lockOn": "Permanent Lock",
      "startDate": "Start Date"
    },
    "EadminCannotModify": "Cannot edit the Eadmin role.",
    "fileType": "File Type",
    "assetManagement": "Asset Management",
    "assetStatistics": "Asset Statistics",
    "hwinfoAsset": "Hwinfo Asset",
    "sfpAsset": "Sfp Asset",
  },
  "System": {
    "dataTotal": "Total Data (Item)",
    "systemFile": "System File",
    "cancel": "Cancel",
    "inputTipPort": "Enter the port.",
    "curAlarmData": "Current Alarm Data",
    "tableName": "Table Name",
    "inputVersion": "Please input Version number to find",
    "hostname": "Hostname",
    "epcOAM": "EPC Platform",
    "productVersion": "Product Version",
    "itemName": "Item Name",
    "continueRun": "Continue",
    "state": "Clear Status",
    "mapLngLimit": "Enter a value in range [–180, 180]",
    "backDelTime": "Backup time or delete time cannot be empty.",
    "busSet": "Operation",
    "remoteTip": "You need to set the corresponding remote user group for remote notification, and can add, modify, or delete users.",
    "module": "Module",
    "importSuccess": "Upload succeeded, configuring file...",
    "ibs_b": "iBS-B",
    "groupExists": "The user group already exists.",
    "personal": "Personalize",
    "keyString": "Enter keyword",
    "keyStringDetail": "Enter keyword in Details",
    "version": "Software Version",
    "node": "NE",
    "smtpCheckTip": "Authentication",
    "ThresholdConfig": "Configure Resource Threshold",
    "systemLogo": "Logo",
    "ri": "Day",
    "ftpPortTip": "1–65535",
    "processing": "Processing ...",
    "missResol": "Process Upon Error",
    "taskName": "Task Name",
    "uploadTipsSize": "Image size cannot exceed 2 MB.",
    "selectDelObj": "Select object to delete.",
    "weeks": "Week",
    "centerLon": "Center Longitude",
    "configMenu": "Config Menu",
    "ftpUser": "FTP Username",
    "num1000": "1,000",
    "backupType": "Backup Type",
    "result": "Results",
    "delTask": "Delete Timed Task",
    "mcsOAM": "MCS Platform",
    "inputTip11": "Enter item name, table name or update time",
    "inputTip7": "Enter keywords to search",
    "inputTip8": "Enter the patch package name keyword you want to search for",
    "inputTip20": "Please enter device ID or Name for search",
    "inputTip21": "Please enter device ID for search",
    "taskFilter": "Advanced Search",
    "minuteRangeInvalid": "The minute interval must be 1–59.",
    "inputTip5": "Delete records n days ago",
    "inputTip6": "Delete the data before n items",
    "inputTip3": "Execute the record n days ago",
    "close": "Close",
    "inputTip4": "Execute the data before n items",
    "addPkg": "Add Version Package",
    "inputTip1": "Enter item name, table name or creation time",
    "email": "Email Address",
    "inputTip2": "1–255 English characters",
    "serviceSet": "Server Settings",
    "uploadFile": "Upload",
    "systemQuery": "System Query",
    "loginAuthenticationMode": "Login Auth Mode",
    "ldapServerConf": "LDAP Server Config",
    "loginAuthenticationMode1": "UNMS Authentication",
    "loginAuthenticationMode2": "kerberos Authentication",
    "backupAndDel": "Backup and Delete",
    "dataLength": "Data Length(M)",
    "smtpTip": "SMTP Server Domain/IP",
    "takeTime": "Time Taken",
    "selectOneMessage": "Select an item.",
    "inputMailTip": "Enter mail title to search",
    "upFileTip": "You can upload only zip files less than 500 MB.",
    "selectedUser": "Selected",
    "MemoryUsage": "Memory Usage (%)",
    "reSuccess": "Succeeded",
    "taskPastDue": "Task Expired",
    "tableCreateTime": "Table Creation Time",
    "changeTime": "Update Time",
    "confirm": "OK",
    "topoConfig": "Topology Config",
    "createGroupInfo": "Create User Group Information",
    "busData": "Event Data",
    "createTime": "Creation Time",
    "missManager": "Task Management",
    "endTime": "End Time",
    "config": "Configuration",
    "configBackupAndRecover": "Config Backup and Recover",
    "oprTime": "Backup Time",
    "db": "DB",
    "inputTip": "Enter the content",
    "activeTask": "Activate",
    "exportFail": "File export failed. Try again...",
    "dayRangeInvalid": "The day interval must be 1–31.",
    "stopRun": "Terminate",
    "nextTime": "Time of Next Execution",
    "geWeek": "Week",
    "editTime": "Edit Time",
    "topoalarmConfig": "Display the Number of Alarms at All Levels",
    "ftpAddressTip": "For example: 192.168.1.1",
    "selectOprSet": "Select Operation Set",
    "tip": "Prompt",
    "uploadingFile": "Uploading file...",
    "ims_hytalk": "IMS_HYTALK Platform",
    "export": "Export",
    "exportAll": "Export All",
    "pmBusManager": "Performance Data",
    "area": "Used Space(MB)",
    "add": "Add",
    "serialNumber": "SN",
    "test": "Test",
    "applyAndTest": "Test",
    "uploadImgWith": "83",
    "ftpPassword": "FTP Password",
    "timeRangeNotNull": "The interval cannot be empty.",
    "telephone": "Mobile",
    "backupNum": "Number of Backups",
    "fileTypeError": "Upload .xlsx files.",
    "uploadFault": "Upload failed.",
    "warn": "Warning Alarm",
    "month": "Month",
    "resultTip": "Result",
    "port": "Port",
    "backDelRange": "Backup or delete capacity cannot be empty.",
    "userGroupName": "User Group Name",
    "takeTimeWithUnit": "Time Taken(Second)",
    "saveMapSuccess": "Saved successfully.",
    "editUserInfo": "Edit User Information",
    "runCycles": "Execution Cycle",
    "uploadConfirm": "Are you sure you want to upload it?",
    "systemManager": "System",
    "fm": "Performance",
    "description": "Description",
    "searchC": "Type",
    "curMoKey": "Field",
    "curMoValue": "Value",
    "selectFileTip": "You can upload only txt files less than 1 MB.",
    "num5000": "5,000",
    "emailNotNull": "Enter email address.",
    "centerLonInput": "Enter longitude of the map center.",
    "uGroup": "User Group",
    "missLogs": "Task Log",
    "soundTip": "You can upload only mp3 files less than 2 MB.",
    "isRunning": "In progress",
    "acArea": "Operation by Capacity",
    "beforeDay7": "7 Days Ago",
    "uploadTipsWidth": "The image width cannot exceed 83 pixels.",
    "every": "Per",
    "uploadSoundTipsType": "You can upload only mp3 files.",
    "deleteFile": "Deleting file...",
    "testLoading": "Testing if the server is connected...",
    "telephoneOrEmail": "Enter either email address or phone number.",
    "mailTip": "Tip: Set the docking parameters between the system and the mailbox server to establish communication between them. When the email notification function is enabled, the system will automatically send email to notify users. In order to ensure the security of sending e-mail, SSL/TLS(Secure Sockets Layer) secure connection is recommended",
    "exportSuccess": "Exporting files...",
    "apply": "Apply",
    "yes": "Yes",
    "mcscl": "MCSCL Platform",
    "geYueDi": "Months",
    "oprType": "Operation Type",
    "ftpTest": "FTP Test",
    "pngTip": "You can upload only .png image (2 MB, 83 x 35). It is recommended that the background of the picture be transparent.",
    "remoteSave": "FTP Server",
    "inputNumber": "Enter number.",
    "pleaseChoose": "Select",
    "ftpPort": "FTP Port",
    "neType": "NE Type",
    "taskId": "Task ID",
    "configEx": "Config Import and Export",
    "checkConfigEx": "Consistency Check",
    "batchInitNECfg": "Batch initialize NE configuration",
    "systemSet": "System Settings",
    "centerLatInput": "Enter the latitude of the center of the map.",
    "copyright": "Copyright",
    "batchExport": "Batch Export",
    "uploadTipsHeight": "The image height cannot exceed 35 pixels.",
    "rowDataNum": "Number of Row Data(Row)",
    "runOpr": "Operation",
    "alarmBusManager": "Alarm Data",
    "inputUser": "Enter user name.",
    "resultNotice": "Send Result",
    "onlyDel": "Delete",
    "userGroupNotNull": "User group name cannot be empty.",
    "num3000": "3,000",
    "alarmPresent": "Alarm Display",
    "uerNameNotNull": "User name cannot be empty.",
    "hisAlarmData": "History Alarm",
    "indexLength": "Index Length(M)",
    "systemName": "System Name",
    "pkgManager": "Package Management",
    "delTime": "Backup Time",
    "addressBook": "Contacts",
    "ftpAddressNotNull": "FTP address cannot be empty.",
    "taskSearchKey": "Enter Task ID or Task Name",
    "confirmDel": "Are you sure you want to delete it?",
    "timeRange": "Backup Time",
    "createUserInfo": "Create User Information",
    "backupArea": "Delete Capacity",
    "mailAccount": "Enter email address.",
    "ip": "IP",
    "endDateInvalid": "The end time must be later than start time.",
    "num10000": "10,000",
    "ftpPortNotNull": "FTP port cannot be empty.",
    "CPUUsage": "CPU Usage (%)",
    "dataNameOrFtpPath": "Data Name or Path",
    "loading": "Loading ...",
    "isInvalid": "Expired",
    "isEffective": "Is Active",
    "acTime": "Operation by Time",
    "userExists": "The user already exists.",
    "copyrightInput": "Enter map copyright information.",
    "spectrum": "Spectrum",
    "reset": "Reset",
    "input1t100": "Enter a positive integer between 1 and 100",
    "backupName": "Backup Name",
    "createTask": "Add Timed Task",
    "input1t15": "Enter a positive integer between 1 and 15.",
    "lastResult": "Last Result",
    "bothSave": "Both",
    "reFault": "Failed",
    "sslTlsTip": "SMTP server requests SSL/TLS secure connection (confirm that SSL/TLS certificate of mailbox server has been installed).",
    "save": "Save",
    "uploadText": "Upload Config File",
    "delPkgTip": "Are you sure you want to delete these packages?",
    "userCheck": "User name",
    "uploadImgHeight": "35",
    "productEle": "Subordinate NE and Platform",
    "mapLatLimit": "Enter a value in range [–90, 90]",
    "detailLog": "Log Details",
    "emailQuery": "Mail Inquiry",
    "startTime": "Start Time",
    "sendEmailTime": "Email Delivery Time",
    "hourRangeInvalid": "The hour interval must be 1–23.",
    "loginAgain": "Login again.",
    "timeTaskId": "Timed Task ID",
    "selectMessages": "Select an item.",
    "analyiseButton": "Import File",
    "analyiseTxtButton": "Export TXT",
    "delArea": "Delete Capacity",
    "runCyclesTip": "Select the execution cycle to display the form of the following block.",
    "change": "Modify",
    "updateTime": "Update Time",
    "mapConfig": "Map",
    "maxLayer": "Max Zoom",
    "backupDays": "Backup Days",
    "storeDays": "Store Days",
    "storeNumbers": "Store Numbers",
    "everyWeekend": "Every Workday",
    "uploadSuccess": "Uploaded successfully.",
    "minLayer": "Min Layer",
    "inputTipIp": "Enter IP.",
    "busManager": "Business Data Management",
    "oprName": "Operation Name",
    "beforeDay30": "30 Days Ago",
    "minor": "Minor Alarm",
    "systemMiss": "System Task",
    "oprArea": "Delete Capacity",
    "sound": "Alarm Tone",
    "uploadSldapPublicKey": "Upload ldap public Key",
    "uploadSldapPublicKeyFail": "Upload ldap public Key fail",
    "uploadSldapPublicKeyDiscribe": "Please upload the ldap public key configuration file.",
    "uploadKerberosKeytab": "Upload kerberos keytab",
    "uploadKerberosKeytabDiscribe": "Please upload the  kerberos keytab configuration file.",
    "ldapServerConfigTip": "Tip: This section describes how to configure parameters for interconnection between the system and the ldap server and establish the communication between the system and the ldap server.",
    "usernameFormatIsIncorrect": "The user name can contain only Latin letters, numbers, and three special characters: _, -, and .",
    "invalidCerFileType": "Invalid file type. The file suffix must be in .cer .crt .pem .der .key .jks format",
    "invalidKeytabFileType": "Invalid file type. The file suffix must be in.keytab format",
    "functionIsUnavailable": "LDAP server is unavailable, contact the administrator.",
    "uploadTheLdapCertificateFile": "Please upload the ldap certificate configuration file.",
    "setTheLdapServiceConfigurationAndSaveIt": "Please set the ldap service configuration and save it",
    "authenticationException": "Authentication failed",
    "ldapUrls": "Ldap IP urls",
    "ldapUsername": "Ldap account name",
    "ldapPassword": "Ldap account password",
    "ldapBase": "Domain name",
    "accountType": "Account Type",
    "UNMAccount": "UNM Account",
    "LDAPccount": "LDAP Account",
    "LdapAuthProfile": "LDAP Auth Profile",
    "LdapAuthProfileBaseDn": "Base DN",
    "LdapAuthProfileAdminBindDn": "Admin Bind DN",
    "LdapAuthProfileAdminBindPassword": "Admin Bind Password",
    "LdapAuthProfileUserSearchDn": "User Search DN",
    "LdapAuthProfileUserSearchScope": "User Search Scope",
    "LdapAuthProfileUserIdAttribute": "User ID Attribute",
    "LdapAuthProfileGroupSearchDn": "Group Search DN",
    "LdapAuthProfileGroupSearchScope": "Group Search Scope",
    "LdapAuthProfileGroupFilter": "Group Filter",
    "LdapAuthProfileGroupMemberAttribute": "Group Member Attribute",
    "LdapAuthProfileSettings": "Settings",
    "LdapAuthProfileSearchScope0": "Scope Base",
    "LdapAuthProfileSearchScope1": "Scope One Level",
    "LdapAuthProfileSearchScope2": "Scope Subtree",
    "baseDnTooltip": "An LDAP Admin Bind DN (Distinguished Name) is a unique identifier used to authenticate an administrative user to an LDAP server",
    "adminBindDnTooltip": "Used to authenticate the administrative user to an LDAP server",
    "adminBindPasswordTooltip": "Used to authenticate the administrative user to an LDAP server",
    "userSearchDnTooltip": "LDAP User Search DN is the root of search for a given user in the LDAP directory. It helps ensure that the search is efficient and focused only on the relevant part of the directory tree where user information is stored.Base DN value is used if this value is not configured.",
    "userSearchScopeTooltip": "LDAP User Search Scope determines the extent of search for the user starting from user search DN.[Base: The search is limited to the specified base DN、One Level: Search only for direct child nodes under the specified DN、Subtree: The search is performed on the entire tree, starting from the specified base DN]",
    "userIdAttributeTooltip": "LDAP User ID Attribute is the login attribute that uniquely identifies a single user record.",
    "groupSearchDnTooltip": "LDAP Group Search DN is the root of search for a given group in the LDAP directory. Only matching groups present in this LDAP directory sub-tree will be checked for user membership.",
    "groupSearchScopeTooltip": "Define the LDAP Group Search Scope using filters for the group starting from the group search DN.[Base: The search is limited to the specified base DN、One Level: Search only for direct child nodes under the specified DN、Subtree: The search is performed on the entire tree, starting from the specified base DN]",
    "groupFilteTooltipr": "LDAP Group Filter is a search filter used to focus the search results to specific group entries within the directory. A search can find many different types of objects under the search DN. Specify the Group Filter to pick up objects specific to the group only. The default group filter is (objectClass=*).",
    "groupMemberAttributeTooltip": "LDAP Group Member Attribute is a multi-valued attribute that can store the DNs of the users who are members of the group. It is used for retrieving data about group members and managing group membership.",
    "ldapConnectionSecurityMode": "LDAP Connection Security Mode",
    "ldapConnectionSecurityModeTooltip": "LDAP Connection Security Mode",
    "ignoreReferrals": "Ignore Referrals",
    "ignoreReferralsTooltip": "Enable Ignore Referrals for the group search to skip referrals links that connect to another LDAP server. This option is deselected by default",
    "enableFullDnForGroupMemberAttribute": "Enable Full DN For Group Member Attribute",
    "enableFullDnForGroupMemberAttributeTooltip": "Enable this option if the group member entries have full DNs instead of just user ID attributes",
    "LDAP": "LDAP",
    "LDAPS": "LDAPS",
    "portTooltip": "Use LDAPS port 636",
    "port636": "636",
    "port389": "389",
    "groupAccessUNM": "Group Access UNM",
    "groupAccessUNMTooltip": "Configure the group name that has the UNM access permission. Multiple group names can be configured. Use commas “,” to separate each group name",
    "ldapAvailabilityTest": "LDAP Availability Test",
    "domainNameTooltip": "The domain name of the AD domain server is specified",
    "saveVerifyTooltip": "Admin Bind DN、User Search DN and Group Search DN included dc value must be the same as the Domain name value",
    "usernameError": "Incorrect user name",
    "passwordError": "Incorrect password",
    "inputTipEmail": "Enter the correct email address.",
    "DiskUsage": "Disk Usage (%)",
    "zipTip": "Incorrect version package format.",
    "major": "Major Alarm",
    "inputInteger": "Enter an integer",
    "fGroup": "Group",
    "neOAM": "OAM",
    "runTime": "Execution Time",
    "day": "Day",
    "deactiveTask": "Pause",
    "executeTask": "Execute",
    "localSave": "Local",
    "level": "Level",
    "sendResult": "Result",
    "resource": "Resource",
    "ftpAddress": "FTP Address",
    "pause": "Pause",
    "tableUncode": "Character Check Code Set of Table",
    "onlyBackup": "Backup",
    "beforeDay15": "15 Days Ago",
    "defaultLayer": "Default Layer",
    "batchImport": "Batch Import",
    "checkImport": "Upload Check",
    "neConfRestore": "Ne Configuration Restore",
    "restoreSuccess": "The NE configuration has been restored successfully",
    "restoreFail": "Anomaly detected in the recovery procedure.",
    "customMiss": "Custom Task",
    "missList": "Task List",
    "enodeb": "eNodeB",
    "no": "No",
    "week": "Week",
    "critical": "Critical Alarm",
    "isReady": "Ready",
    "delete": "Delete",
    "editGroupInfo": "Edit User Group Information",
    "editTask": "Modify Task",
    "fileNotNull": "File cannot be empty.",
    "hour": "Hour",
    "optionalUser": "Available",
    "systemNotice": "System Notification",
    "alarm": "Alarm",
    "selectTimeRange": "Select time range",
    "dataManager": "Data Management",
    "selectFile": "Select File",
    "select3GPPYysTaskOsType": "Select 3GPP or custom task operation type",
    "productType": "Product Model",
    "os": "Operating System",
    "invalidIp": "Invalid IP address.",
    "emailTitle": "Subject",
    "addPkgObj": "Add an adapter package.",
    "imsOAM": "IMS Platform",
    "minute": "Minute",
    "executionInterval": "Execution Interval",
    "alarmType": "Alarm Type",
    "uploadTipsType": "Only .png image is supported.",
    "mmlMiss": "MML Task",
    "passwordCheck": "Confirm Password",
    "centerLat": "Center Latitude",
    "backupTime": "Backup Time",
    "user": "User",
    "remarks": "Remarks",
    "3gppMiss": "3GPP",
    "backup": "backup",
    "recoveryResult": "recovery result",
    "generateCfgFile": "Generate configuration File",
    "inputNodeIdSection": "Please input node id range to find,separated by hyphens '-'",
    "batchInitNECfgCheckSuccess": "The template verification is successful, and the result is being exported",
    "batchInitNECfgCheckFail": "If the template verification fails, modify parameters and upload the template again.",
    "executeCMTaskPrompt": "After this operation, northbound CM files will be collected based on the 'Store days' parameter.",
    "executeHMTaskPrompt": "After this operation, northbound HM files will be collected based on the 'Store days' parameter.",
    "executePMTaskPrompt": "After this operation, northbound PM files will be collected based on the 'Store days' parameter.",
    "selectStandardBs": "Generate configuration data",
    "standardBsWarning": "Please select a standard eNodeB.",
    "generate": "Generate configuration information for selected eNodeB",
    "generateAll": "Generate configuration information for all eNodeB",
    "standardDes": "The generated configuration information is configured as the standard eNodeB selected on this page.",
    "executeTaskConfirm": "Do you want to execute?",
    uploadConfig: {
      uploadConfig: 'Upload NE Config To UNM',
      queryPrompt: 'Please input the search condition in correct search format: id or id range separated by hyphens \'-\'.',
      uploadCurrentPage: 'upload',
      uploadAll: 'uploadAll',
      uploadAllPrompt: 'Are you sure you want to upload config from NE to UNM for all online eNodeB?'
    },
  },
  "Profile": {
    "cancel": "Cancel",
    "pleaseSelectDatas": "Select an item.",
    "addProfile": "Add Subscription Profile",
    "pdnProfileList": "PDN Profile",
    "addProfileSuccess": "Subscription profile added successfully.",
    "qryProfileSuccess": "Subscription profile queried successfully.",
    "logger": "Log",
    "delProfileSuccess": "Subscription profile deleted successfully.",
    "profileMaxDl": "Max Downlink（UE-AMBR/Kbps）",
    "pdnApnName": "APN Name",
    "zonalCode": "Zone Code",
    "selected": "You have selected",
    "profileMaxUl": "Max Uplink（UE-AMBR/Kbps）",
    "add": "Add",
    "nelist": "NE List",
    "item": "items",
    "failed": "Failed",
    "delConfirm": "Are you sure you want to delete it?",
    "pleaseSelectOneData": "Select only one item.",
    "ntwAccessMode": "Network Access Mode",
    "maxadd": "At most",
    "success": "Succeeded",
    "profileId": "Subscription Profile ID",
    "items": "items",
    "repeatCode": "Duplicate zone code.",
    "charAt32": "Enter 0-32 characters.",
    "profileName": "Profile Name",
    "repeatMCCMNC": "Duplicate PLMN.",
    "chargingChars": "UE Charging Characteristics",
    "RelatedProfile": "Associated Subscription Profile",
    "remove": "Delete",
    "zonalCodeObj": "Zone Code",
    "crumb": "Subscriber/LTE Management/Subscription Profile",
    "inquiry": "Inquiry",
    "pleaseSelectNE": "Select NE.",
    "subsPeriodicRauTauTimer": "Subs Periodic RAU/TAU Timer（s）",
    "modProfileSuccess": "Subscription profile modified successfully.",
    "dftPDNProfileID": "Default PDN Profile ID",
    "refresh": "Refresh",
    "modProfile": "Modify Subscription Profile",
    "pdnProfileLst": "Associated PDN Profile ID",
    "pdnProfileId": "Associated PDN Profile ID",
    "confirm": "OK",
    "modify": "Modify",
    "pdnProfileName": "PDN Profile Name",
    "minadd": "At least",
    "maxadd11": "Cannot exceed 11 items.",
    "mccMncCode": "MCC-MNC",
    "mccmncObj": "MCC-MNC"
  },
  "Spectrum": {
    "ui_pt_taskrespnull": "The sweep result is reported abnormally, please stop the report. If you want to continue, please try again.",
    "ui_pt_taskstatus_submit": "Submitting...",
    "ui_pt_spectrumchoose": "Select eNodeB and cell.",
    "ui_spectrumphycellid": "Physical Cell",
    "ui_pt_spectrumave": "Average",
    "ui_pt_spectrumseconds": "seconds",
    "ui_pt_spectrumdelete": "Delete",
    "ui_pt_spectrumantdgm": "Antenna Interfere Sweep Diagram",
    "ui_pt_removespectrumtask": "Select a task.",
    "6906": "The query task is full, please wait.",
    "6908": "Failed to stop the task.",
    "ui_pt_spectrum30min": "30 minutes",
    "6907": "The task is abnormal, please stop it. If you want to continue, please try again.",
    "ui_pt_spectrumsuspendre": "Pause Refresh",
    "6909": "Failed to delete the task.",
    "ui_pt_searchNe": "Search NE by NE ID or NE name",
    "ui_pt_spectrumbuild": "Create Spectrum Sweep Task",
    "ui_pt_spectrummin": "Min",
    "ui_pt_taskstatus_execute": "In progress",
    "ui_pt_spectrumNoStop": "In progress",
    "6900": "A task is being executed in the current cell, please try again later.",
    "6902": "The task in the current state cannot be deleted.",
    "6901": "Failed. Task has been closed or submitted, please try again later.",
    "6903": "Cannot stop the finished task.",
    "ui_pt_stoptaskfailed": "Failed to stop task.",
    "ui_pt_taskresperror": "The sweep result is reported abnormally, please stop the report. If you want to continue, please try again.",
    "ui_pt_spectrum2s": "2s",
    "ui_pt_spectrumadd": "Create",
    "ui_pt_spectrumpeakmon": "Peak Monitor",
    "spectrum_manager": "Spectrum",
    "ui_pt_spectrumchfindex": "Subframe Index",
    "ui_pt_taskstatus_end": "Ended",
    "ui_pt_rbOption": "RB RSSI (Unit: dBm)",
    "ui_pt_spectrumcycle": "Scan Cycle",
    "ui_pt_spectrumdelconform": "Are you sure you want to delete it?",
    "ui_pt_spectrum1week": "1 week",
    "ui_pt_spectrumcantdelete": "Cannot be deleted.",
    "ui_pt_spectrum1min": "1 minute",
    "400": "You cannot delete the picture being used.",
    "401": "You cannot delete system default pictures.",
    "ui_pt_spectrumstopped": "Stopped",
    "ui_pt_spectrum10s": "10s",
    "402": "The picture has already been deleted.",
    "ui_pt_result": "Result",
    "ui_pt_taskstatus_stop": "Stopping...",
    "ui_pt_taskstatus_failed": "Failed",
    "6911": "Failed to query the sweep data by time.",
    "ui_pt_spectrum4hour": "4 hours",
    "6910": "Failed to query sweep data.",
    "ui_pt_spectrum10min": "10 minutes",
    "6912": "Failed to view the frequency sweep record.",
    "ui_pt_taskstatus_waiting": "Waiting...",
    "ui_pt_enodebid": "eNodeB ID",
    "ui_ok": "OK",
    "ui_pt_spectrum1s": "1s",
    "ui_pt_spectrumDuration": "Duration",
    "ui_pt_spectrumunit": "Unit",
    "ui_pt_spectrumphycellid": "Physical Cell ID",
    "NElist": "NE List",
    "ui_pt_spectrum5min": "5 minutes",
    "ui_pt_spectrumtaskcreate": "Create",
    "ui_oper": "Operation",
    "ui_pt_spectrumstop": "Stop",
    "ui_pt_spectrumavemon": "Average Monitor",
    "ui_pt_spectrumfredgm": "Frequency Interfere Sweep Diagram",
    "ui_pt_neidorname": "NE ID or name",
    "ui_pt_spectrumlist": "Spectrum Sweep Task List",
    "258": "NEs already exist in this segment.",
    "ui_pt_cell": "Cell ID",
    "ui_pt_spectrumsectorid": "Sector ID",
    "ui_pt_spectrumtimlin": "Timeline",
    "ui_pt_spectrum1hour": "1 hour",
    "ui_Duration": "Duration:",
    "ui_pt_spectrumsca": "Spectrum Sweep",
    "ui_spectrumsectorid": "Sector ID",
    "ui_cell": "Cell",
    "ui_pt_starttime": "Start Time",
    "ui_cycle": "Cycle:",
    "ui_pt_spectrummax": "Max",
    "ui_pt_spectrumUnit": "Unit: (Minute)",
    "ui_pt_endtime": "Stop Time",
    "ui_pt_taskstatus": "Task Status",
    "ui_pt_createtaskfailed": "Failed to create task.",
    "ui_pt_command": "Command",
    "ui_pt_spectrumexpimg": "Export Image",
    "ui_pt_SpectrumTaskList": "Spectrum Sweep Task List",
    "ui_cancell": "Cancel",
    "ui_pt_spectrum5s": "5s",
    "ui_pt_spectrum1day": "1 day"
  },
  "UE": {
    "ue_selected": "Selected",
    "ue_camera_name": "Camera Name",
    "ue_alias": "UE Alias",
    "legend": "Legend",
    "ue_sinr2": "SINR2",
    "ue_sinr1": "SINR1",
    "ueSelectDatas": "Select an item.",
    "select_ue": "Select UE",
    "ue_nrsrp1": "Neighbor Cell RSRP1",
    "ue_nrsnp2": "Neighbor Cell RSRP2",
    "ue_state_off": "Offline",
    "ue_chart": "Subscribe UE Chart",
    "ue_dl_packet_rate": "Downlink Packet Rate",
    "ue_state_idle": "Idle",
    "ue_select_limit": "Select at most 5 UEs.",
    "ue_dl_data": "Downlink Throughput",
    "ue_ip": "IP Address",
    "ueConfirm": "OK",
    "neList": "NE List",
    "ue_base_enodeb": "Home eNB Alias",
    "ueCancell": "Cancel",
    "bs_online_count": "Online eNBs:",
    "ue_ul_data": "Uplink Throughput",
    "legend_bs": "eNB",
    "ue_state_up": "Online",
    "ue_bs_id": "eNodeB ID",
    "ue_camera": "Camera",
    "ue_rsrp1": "Serving Cell RSRP1",
    "ue_ul_Traffic": "Uplink Traffic",
    "ue_imsi": "IMSI",
    "ue_rsnp2": "Serving Cell RSRP2",
    "pleaseSelectNe": "Select an NE.",
    "ue_dl_Traffic": "Downlink Traffic",
    "ueDetailData": "Details",
    "status": "Clear Status",
    "select_ue_data": "Select UE.",
    "ue_mac": "MAC Address",
    "ue_state": "UE Status",
    "ueSearch": "Query",
    "ue_ul_packet_rate": "Uplink Packet Rate",
    "ue_traffic": "Uplink and Downlink Traffic",
    "ue_search_imsi": "Search IMSI",
    "ueSelectOneData": "Select only one item.",
    "latLng": "Coordinates",
    "ueShowMap": "UE Map",
    "ueManager": "UE Management",
    "ue_bs_name": "eNodeB Alias",
    "ue_online_count": "Online UEs:",
    "legend_ue": "UE",
    "ueTraffic": "UE Traffic"
  },
  "Monitor": {
    "assetType": "Asset Type",
    "localtion": "Localtion",
    "sn": "SN",
    "vid": "VID",
    "Version": "Version",
    "assetInfoSync": "Asset Info Sync",
    "assetSearchPlaceholder": "Enter the NE ID, NE name, or asset type. The NE ID ranges from 10 to 100",
    "hwinfoAsset": "Hwinfo Asset",
    "sfpAsset": "Sfp Asset",
    "assetRadioStatistic": "Asset Radio Statistic",
    "assetQuantityStatistics": "Asset Quantity Statistics",
    "hwinfoAssetTypeStatistic": "Hwinfo Asset Type Statistic",
    "sfpAssetTypeStatistic": "Sfp Asset Type Statistic",
    "task": {
      "sampleStart": "Start Time",
      "product": "Product Name",
      "deleteMonitor": "Tasks in progress cannot be deleted.",
      "deactiveMonitor": "Only the executed task can be suspended",
      "activeMonitor": "Only the suspended task can be executed",
      "oneActiveMonitor": "Only one executing task can exist",
      "titleName": "System Monitor Task",
      "monitoringServiceProcess": "Monitoring Service Process",
      "exeFinish": "Done",
      "sampleEnd": "End Time",
      "notStarted": "Not started",
      "inUse": "In progress",
      "taskName": "Task Name",
      "CMService": "CM Service",
      "PMService": "PM Service",
      "FMService": "FM Service",
      "exeState": "Task State"
    },
    "record": {
      "systemInfo": "System Info",
      "product": "Product",
      "memory": "Memory Usage Threshold（%）",
      "titleName": "System Monitor Record",
      "recoreTime": "Record Time",
      "memoryThreshold": "Memory Usage Threshold（%）",
      "cpuThreshold": "Cpu Usage Threshold（%）",
      "diskSpaceThreshold": "Disk Space Usage Threshold（%）",
      "diskSpace": "Disk Space Usage Threshold（%）",
      "cpu": "Cpu Usage Threshold（%）",
      "taskId": "Task ID",
      "networkRxRate": "Network Rx Rate/s",
      "networkTxRate": "Network Tx Rate/s",
      "IOPSKbRead": "IOPS kB_read/s",
      "IOPSKbWrite": "IOPS kB_wrtn/s",
      "queueOperands": "Total number of stored queue operations/s",
      "databaseDiskSpaceIsUsed": "Database disk space used in the file system",
      "snmpAlarmDataSize": "SBI alarm number/s",
    },
    "systemLog": {
      "logType": "Log Type",
      "startupSuccess": "Start succeeded. Please check later.",
      "product": "Product",
      "startupFail": "The product has been started.",
      "shutdownFail": "The product has been stopped.",
      "start": "Start Log",
      "run": "Run Log",
      "message": "Remarks",
      "processInfo": "Process Info",
      "productEnd": "Stop Time",
      "systemInfo": "System Info",
      "titleName": "System Monitor Log",
      "recordTime": "Record Time",
      "shutdownSuccess": "Stop succeeded. Please check later.",
      "startup": "Start",
      "productStart": "Start Time",
      "operation": "Start or Stop Product",
      "shutdown": "Stop"
    },
    "realTimeMonitoring": {
      "crumb": "Real Time Monitoring",
      "CPUUtilization": "CPU Utilization",
      "memoryTotal": "Memory Total",
      "memoryUsage": "Memory Usage",
      "memoryUtilization": "Memory Utilization",
      "diskUsage": "Disk Usage",
      "diskSize": "Disk Size",
      "diskUtilization": "Disk Utilization",
    },
    "monitor": "System Monitor",
    "placeholder": {
      "sampleStart": "Enter the start time",
      "product": "Enter the product",
      "sampleEnd": "Enter the end time",
      "taskName": "Enter the system monitor log"
    },
    "error": {
      "serviceRunning": "Service running",
      "serviceStoped": "Service stopped",
      "partOfNeOffline": "Part Of Ne Offline",
      "enodebProcessException": "Enodeb Process Exception",
    }
  },
  "DataManagent": {
    "neid": "NE ID",
    "import": "Batch Import",
    "opType": "Operation Type",
    "systemUser": "System User",
    "neVersion": "NE Version",
    "distIp": "Destination IP",
    "chooseNeidTip": "Select an NE",
    "chooseDataTip": "Select an item",
    "fail": "Failed",
    "opResult": "Operation Result",
    "crumb": "Subscriber/Data Management",
    "opTime": "Operation Time",
    "success": "Succeeded",
    "clientIp": "Client IP",
    "createDataFileFail": "Failed to generate data file.",
    "export": "Export",
    "requestTimeOut": "Timeout"
  },
  "PDN": {
    "cancel": "Cancel",
    "pleaseSelectDatas": "Select an item.",
    "chargingCharacteristics": "Charging Characteristics",
    "addProfile": "Add Profile",
    "apnAMBR_DL": "APN AMBR DL(KBPS)",
    "pgwHostName": "PGW Host Name",
    "addProfileSuccess": "PDN profile added successfully.",
    "allowed": "Allowed",
    "logger": "Log",
    "qryProfileSuccess": "PDN profile queried successfully.",
    "pgwAddrLabel": "PGW Address",
    "delProfileSuccess": "PDN profile deleted successfully.",
    "required": "This field cannot be empty.",
    "apnAMBR_UL": "APN AMBR UL(KBPS)",
    "qci": "QCI",
    "arp6": "PVI",
    "arp0": "PCI",
    "selected": "You have selected",
    "add": "Add",
    "vplmnAllowed": "Access in Roaming Area",
    "nelist": "NE List",
    "item": "items",
    "noPreemptable": "Disabled",
    "arp2_5": "PL",
    "failed": "Failed",
    "preemptedable": "Enabled",
    "delConfirm": "Are you sure you want to delete it?",
    "pleaseSelectOneData": "Select only one item.",
    "pgwIpv6Addr": "PGW IPv6 Address",
    "profileId": "PDN Profile ID",
    "success": "Succeeded",
    "partofpdn": "This value should belong to associated PDN profile ID.",
    "pdnType": "PDN Type",
    "profileName": "Profile Name",
    "apnName": "APN Name",
    "pgwIpv4Addr": "PGW IPv4 Address",
    "remove": "Delete",
    "pgwEnableLabel": "Use Subscribed PGW",
    "pgwHostLabel": "PGW Host",
    "crumb": "Subscriber/LTE Management/PDN Profile",
    "ipv4": "IPv4",
    "inquiry": "Inquiry",
    "ipv6": "IPv6",
    "pleaseSelectNE": "Select an NE.",
    "unallowed": "Disallowed",
    "doubleStack": "Dual Stack",
    "modProfileSuccess": "PDN profile modified successfully.",
    "preemptable": "Enabled",
    "refresh": "Refresh",
    "modProfile": "Modify Profile",
    "confirm": "OK",
    "modify": "Modify",
    "noPreemptedable": "Disabled",
    "pgwRealmName": "PGW Realm"
  },
  "Plmn": {
    "profileName": "Template Name",
    "addProfile": "Add PLMN Template",
    "mnc": "MNC",
    "amDataProfile": "AM-DATA Template",
    "modProfileSuccess": "PLMN template modified successfully.",
    "addProfileSuccess": "PLMN template added successfully.",
    "amDataProfileId": "Associated AM-DATA Template ID",
    "qryProfileSuccess": "PLMN template queried successfully.",
    "amDataProfileName": "AM-DATA Template Name",
    "modProfile": "Modify PLMN Template",
    "mcc": "MCC",
    "delProfileSuccess": "PLMN template deleted successfully.",
    "snssaiProfileId": "Associated S-NSSAI Template ID",
    "snssaiProfileIds": "Associated S-NSSAI Template",
    "crumb": "Subscriber/UDM Management/PLMN Template",
    "profileId": "PLMN Template ID",
    "amDataProfileIds": "Associated AM-DATA Template",
    "snssaiProfile": "S-NSSAI Template",
    "snssaiProfileName": "S-NSSAI Template Name"
  },
  "Supi": {
    "modProfileSuccess": "Subscriber template modified successfully.",
    "addProfileSuccess": "Subscriber template added successfully.",
    "exceedGpsi": "An GPSI exceeds 15 digits.",
    "qryProfileSuccess": "Subscriber template queried successfully.",
    "supi": "SUPI",
    "delProfileSuccess": "Subscriber template deleted successfully.",
    "gpsi": "GPSI",
    "ipv6Addr": "Static IPv6",
    "crumb": "Subscriber/UDM Management/Subscriber Management",
    "character15": "5–15 characters",
    "supiSearch": "Enter SUPI to search",
    "exceedSupi": "An SUPI exceeds 15 digits.",
    "userSubProfileId": "Associated Subscription Profile",
    "ipv4Addr": "Static IPv4",
    "supiRange": "SUPI Range"
  },
  "AmData": {
    "RFSPindex": "RFSP Index",
    "profileName": "Template Name",
    "addProfile": "Add AM-DATA Template",
    "addProfileSuccess": "AM-DATA template added successfully.",
    "qryProfileSuccess": "AM-DATA template queried successfully.",
    "ueAmbrDown": "Max Downlink Bandwidth (UE-AMBR/KBPS)",
    "edrx": "Edrx Parameter Table",
    "areaType3": "Forbidden Area",
    "areaType2": "Non-allowed Area",
    "delProfileSuccess": "AM-DATA template deleted successfully.",
    "areaType1": "Allowed Area",
    "RatType": "RAT Type",
    "crumb": "Subscriber/UDM Management/AM-DATA Template",
    "allowAreaType": "Service Area Restriction Type",
    "areaType": "Area Type",
    "tac": "TAC",
    "mico1": "Disallowed",
    "mico0": "Allowed",
    "notAllowOne": "It is not allowed to fill in only one field.",
    "areaTypeNotNull": "Select the area type.",
    "modProfileSuccess": "AM-DATA template modified successfully.",
    "areaForbid": "Service Area Restriction",
    "edrxValue": "Edrx Value",
    "ratType": "Restriction Type",
    "modProfile": "Modify AM-DATA Template",
    "areaCode": "Area Code",
    "profileId": "AM-DATA Template ID",
    "forbidAreaCode": "Forbid TAC",
    "forbidTac": "Forbid TAC",
    "ueAmbrUp": "Max Uplink Bandwidth (UE-AMBR/KBPS)",
    "conflict": "Area type conflict.",
    "micoAllowed": "MICO Mode"
  },
  "Pm": {
    "exportCustomKPI": "Export custom KPI",
    "exportTemplate": "Export Template",
    "cancel": "Cancel",
    "thresholdSettingFail": "Threshold settings failed.",
    "taskDespOver256": "No more than 256 characters in task description.",
    "neOffline": "The NE is offline.",
    "atLeastOne": "Select at least one item.",
    "editTemplate": "Edit Template",
    "importantAlarmUpperMore": "The upper limit of the critical alarm threshold must be larger than the lower limit.",
    "taskDescription": "Task Description",
    "del": "Delete",
    "addReportTask": "Add Report Task",
    "secondaryAlarmUpperMore": "The upper limit of the minor alarm threshold must be larger than the lower limit.",
    "taskState": "Task Status",
    "notCloseHome": "Do not close the homepage.",
    "consistencyQuery": "Check Consistency",
    "checkUniformity": "Check Consistency",
    "updateReportTask": "Update Report Task",
    "importantAlarm": "Critical Alarm",
    "taskStatus": "Task Status",
    "secondaryAlarmLowerNoInclude": "Lower limit (not included)",
    "disableTask": "Disable Task",
    "selectResourcePlease": "Select the correct source.",
    "active": "Activated",
    "measureObjectTypeCode": "Measurement Object Type ID",
    "gnbPmDataQuery": "Query Performance Data",
    "unknownError": "Unknown error",
    "pmReportManagement": "Performance Report Management",
    "counterCreateTime": "Indicator Creation Time",
    "realtime_task_createTask": "Create Real-time Measurement Task",
    "byIndicator": "by indicator",
    "syncTime": "Synchronization Time",
    "addToFollow": "Add",
    "taskList": "Task List",
    "mostNineCounterCanView": "You can query 9 indicators at most.",
    "notInputSpace": "No spaces allowed.",
    "endTimeFrame": "End Time Frame",
    "oneHour": "1 hour",
    "delTask": "Delete Task",
    "search": "Search",
    "taskNameOver60": "No more than 60 characters in task name.",
    "failedToStart": "Failed to start task.",
    "modCustomCounter": "Modify Custom Indicator",
    "selectDataPlease": "Select an item.",
    "wednesday": "Wednesday",
    "pleaseInput": "Input",
    "emergencyAlarmUpperInclude": "Upper limit (included)",
    "uploadBeginTime": "Reacquisition Start Time",
    "thresholdUpdateSuccess": "Thresholds updated successfully",
    "thursday": "Thursday",
    "thresholdEmptyDelete": "Thresholds are all empty and the previously set thresholds will be cleared. Do you want to continue?",
    "counterSpace": "Space Granularity",
    "deleteSuccessfully": "Deleted successfully",
    "startUp": "Start",
    "delCustomCounter": "Delete Custom Indicator",
    "days": "Day",
    "reportTaskLogTile": "Report Task Log",
    "promptAlarmUpperInclude": "Upper limit (included)",
    "activeTask": "Activate Task",
    "resourceOffline": "The resource is offline.",
    "pmManagement": "Performance",
    "endNoEarilerThanCurrent": "The end time cannot be earlier than the start time.",
    "nonReal": "Non-real Time",
    "editTime": "Edit Time",
    "promptAlarm": "Warning Alarm",
    "emergencyAlarm": "Critical Alarm",
    "pauseTime": "Pause Time",
    "inputSearhString": "Enter search conditions",
    "finish": "Done",
    "export": "Export",
    "info": "Info",
    "defaultPermanent": "The default is permanent.",
    "add": "Add",
    "counterFormula": "Indicator Formula",
    "defaultNow": "The default is the current time",
    "ne_name": "Resource Name",
    "dataType": "Data Type",
    "samplingPeriod_unit": "Statistics Period(s)",
    "thresholdAlarm": "Threshold Alarm",
    "alertInvalidTime": "In the active status, the indicator expiry time cannot be earlier than the current time.",
    "onlyNumAndLetter": "Only digits and letters are allowed.",
    "allAlarm": "All Alarms",
    "integrityCheck": "Check Data Integrity",
    "success": "Succeeded",
    "emergencyAlarmLowerNoInclude": "Lower limit (not included)",
    "nextStep": "Next",
    "oneMinute": "1 minute",
    "resourcePort": "Resource Port",
    "frame": "Chassis No.",
    "reportTaskLog": {
      "all": "All",
      "statusFail": "Failed",
      "statusSuccess": "Succeeded",
      "message": "Remarks",
      "exeTime": "Task Statistics Deadline",
      "status": "Status"
    },
    "createPmTask": "Create Task",
    "neLatest": "Latest data of all selected NEs",
    "counterUnit": "Unit",
    "pleaseSelectCounter": "Select indicator",
    "pleaseInputInteger": "Enter an integer",
    "selectNe": "Select NE",
    "promptAlarmUpperAndLowerAllNeed": "Both the upper and lower limits of the warning alarm threshold must be set.",
    "measurementObjectClassify": "Measurement Object Type",
    "alertHeader": "Warning",
    "kpiChartEdit": "Configure KPI Chart",
    "secondaryAlarmUpperAndLowerAllNeed": "Both the upper and lower limits of the minor alarm threshold must be set.",
    "resourceList": "Resource List",
    "pcs": "pcs",
    "timeShouldEarlierThanCurrent": "The reacquisition end time should be earlier than the current time.",
    "showTemplate": "Query Report Template",
    "custom": "Custom",
    "pmAlarmManagement": "Performance Alarm Management",
    "noSetting": "Not set",
    "customCounter": "Custom Indicator",
    "oneDay": "1 day",
    "modify": "Modify",
    "dataLatest": "Latest data of one NE",
    "preStep": "Back",
    "processCode": "Process ID",
    "bySeat": "by position",
    "deleteTask": "Delete Task",
    "neType": "NE Type",
    "uploadAlarm": "Reacquisition Alarm",
    "thresholdActiveStatus": "Threshold Activation Status",
    "taskTimeRemaining_unit": "Remaining Time(s)",
    "measuringPosition": "Measurement Position",
    "paramType": "Performance Parameter Type",
    "number": "Qty",
    "inactive": "Deactivate",
    "searchByName": "Search by name",
    "statistic_cycle": "Statistics Period(s)",
    "taskNameNull": "Task name cannot be empty.",
    "indicatorFormulaColumn": "Indicator Formula",
    "exportChart": "Export Image",
    "saveDataOrNot": "Save Data",
    "counterVal": "Indicator Value",
    "alertData1": "Select an item.",
    "pleaseSelectUploadBeginTime": "Select start time.",
    "ip": "IP",
    "realTime": "Real-time",
    "kpiChartAnalyz": "Performance Chart",
    "system": "System",
    "indicatorDesc": "Description",
    "indicatorState": "Indicator Status",
    "samplingPeriod": "Sampling Period",
    "customCounterList": "Custom Indicator List",
    "showMeasureCustom": "Show Custom Measure",
    "uniformityState": "Check Consistency",
    "createTask": "Create/Modify Task",
    "reportTime": "Report Time",
    "indicatorName": "Indicator Name",
    "selectResource": "Select resource",
    "counterParamType": "Parameter Type",
    "taskDuration_unit": "Task Duration(s)",
    "counterTypeId": "Measurement Object ID",
    "reportTaskTile": "Report Task",
    "selectedKpiPath": "Selected KPI Path",
    "selectIndicator": "Select indicator",
    "monday": "Monday",
    "selectNePlease": "Select correct NE.",
    "end_time": "Stop Time",
    "modifyTask": "Modify Task",
    "ascending": "Ascending",
    "thresholdDetail": "Threshold Details",
    "inconsistent": "Inconsistent",
    "enableTask": "Enable Task",
    "disable": "Disable",
    "templateCreatePeople": "Template Creator",
    "realOrNo": "Real-time/Non-real Time",
    "complete": "Done",
    "noPlan": "No Plan",
    "resourceType": "Resource Type",
    "searchNe": "Search NE",
    "uploadBaseTimeError": "Incorrect base time format",
    "alertInvalidDate": "Enter a valid date.",
    "measureCustom": "Custom Measure",
    "hangup": "Pause",
    "second": "step 2",
    "mode": "Standard",
    "pmTaskManagement": "Performance Task Management",
    "oClock": "Hour",
    "pleaseSelectSpaceNode": "Select a space granularity node.",
    "dataCollection": "Data Task",
    "all": "All",
    "importantAlarmUpperInclude": "Upper limit (included)",
    "alertFormula3": "The indicators in the formula do not match measurement object.",
    "alertFormula2": "There are no indicators in the formula.",
    "ms": "ms",
    "alertFormula4": "The length of formula exceeds 512 characters.",
    "kbps": "KBPS",
    "multiInstanceChartStatistics": "Multi-Instance Chart Statistics",
    "hangUpStartTime": "Suspended From",
    "alertFormula1": "Indicator formula cannot be empty.",
    "real": "Real-time",
    "samplingStartTime": "Start Time",
    "secondaryAlarm": "Minor Alarm",
    "doubleClickChoose": "Double-click to select indicator",
    "statusSetting": "Status Settings",
    "addMonitorTask": "Add Task Monitor",
    "unit": "Indicator Unit",
    "thirtyMinutes": "30 minutes",
    "chooseObject": "Select measurement object",
    "ne": "NE",
    "resultEmpty": "No data",
    "pleaseSelectMeasureObj": "Select the measurement object.",
    "no": "No",
    "hasSameIndicatorName": "Indicator with the same name already exists.",
    "slot": "Slot No.",
    "switch": "Switch",
    "times": "times",
    "counterList": "Indicator List",
    "today": "Today",
    "dataMining": "Replenish Data",
    "friday": "Friday",
    "activeThreshold": "Activation Threshold",
    "queryInfo": "Query",
    "oneMonth": "1 month",
    "determine": "OK",
    "delTemplate": "Delete Template",
    "alertRequired": "This field cannot be empty.",
    "reportTemplate": "Report Template",
    "establishTask": "Create Task",
    "massEstablishTask": "Mass Create Task",
    "massEstablishTaskTotal": "Total Number Of Tasks",
    "massEstablishTaskSuccess": "Success Number Of Tasks",
    "massEstablishTaskError": "Failure Number Of Tasks",
    "massEstablishTaskErrorDetail": "Failure Details",
    "cellMeasure": "Cell Measurement",
    "alarmType": "Alarm Type",
    "thresholdSetStatus": "Threshold Status",
    "waitCommandFinish": "Wait for the command to finish.",
    "chooseCounters": "Select indicator",
    "indicatorAndThreshold": "Indicator and Threshold Management",
    "singleInstanceChartStatistics": "Single-Instance Chart Statistics",
    "systemTemplate": "System Template",
    "selectIndicatorPlease": "Select indicator.",
    "selectIndicatorCannotCross": "Selected indicators cannot cross measurement objects",
    "ne_type_id": "Resource Type",
    "resourceId": "Resource ID",
    "taskUploadSetting": "Reacquisition Settings",
    "hasSameTaskName": "Task with the same name already exists.",
    "templateUpdateTime": "Template Update Time",
    "measureCycle": "Sampling Period",
    "measureCycleTips": "The report period of NE is 15 min, UNM support to query and export data by different period.",
    "upperUnlimited": "Upper unlimited",
    "pmDataLineChart": "Performance Data Line Chart",
    "assocId": "Association ID",
    "cellId": "Cell ID",
    "enodebId": "eNodeB ID",
    "beyondTheScope": "Out of scope",
    "reportTaskDetailed": "Report Task Details",
    "resourceIp": "Resource Port",
    "taskID": "Task ID",
    "failedToCreate": "Failed to create task.",
    "resourceVersion": "Resource Version",
    "customTemplate": "Custom Template",
    "realTimeByIndicator": "Real-time Measurement Task (by indicator)",
    "taskName": "Task Name",
    "timeMode": "Time Mode",
    "oneWeek": "1 week",
    "reportGnbData": "Report Data",
    "saturday": "Saturday",
    "measurePlan": "Measurement Plan",
    "subnetWork": "Subnet Node",
    "invalidTime": "Expiration Time",
    "emergencyAlarmUpperMore": "The upper limit of the critical alarm threshold must be larger than the lower limit.",
    "performanceIndicatorManage": "Performance Indicator Management",
    "alarmLevel": "Alarm Level",
    "latest": "Latest",
    "cycleMeasurement": "Periodic Measurement",
    "Intodb_time": "Data Import Time",
    "begTimeFormatError": "Incorrect start time format.",
    "confirm": "OK",
    "twentyMinutes": "20 minutes",
    "sortMethod": "Sort by",
    "consistentState": "Consistent Status",
    "secondaryAlarmUpperInclude": "Upper limit (included)",
    "promptAlarmUpperMore": "The upper limit of the warning alarm threshold must be larger than the lower limit.",
    "endTime": "Stop Time",
    "resource_name": "Resource Name",
    "systemCounterList": "System Indicator List",
    "cabinet": "Shelf No.",
    "measurementObject": "Measurement Object",
    "createTaskUser": "Creator",
    "notSet": "Not set",
    "syncTask": "Sync Task",
    "begTimeNull": "Start time cannot be empty.",
    "queryWillDel": "Are you sure you want to delete it?",
    "templateCreateTime": "Template Creation Time",
    "measureObj": "Measurement Object",
    "cell_id": "Cell ID",
    "cell_name": "Cell Name",
    "plmn": "PLMN",
    "scell_id":"SRC Cell",
    "dcell_id":"DEST Cell",
    "splmn":"SRC PLMN",
    "dplmn":"DEST PLMN",
    "ne_id": "Resource ID",
    "fiveMinutes": "5 minutes",
    "importantAlarmUpperAndLowerAllNeed": "Both the upper and lower limits of the major alarm threshold must be set.",
    "customCounterTypeId": "Custom Measure ID",
    "uploadTask": "Reacquisition Task",
    "query": "Query",
    "multiResourceChart": "Multi-Resource Dimension Chart",
    "resourceName": "Resource Name",
    "sysTemplateNoEdit": "Cannot edit the system template.",
    "measureObjName": "Measurement Object Name",
    "emergencyAlarmUpperAndLowerAllNeed": "Both the upper and lower limits of the critical alarm threshold need to be set.",
    "synchronousDownload": "Synchronize Task",
    "collectCycle": "Measurement Cycle",
    "lastWeek": "Last Week",
    "hangupThreshold": "Suspend Threshold",
    "start_time": "Start Time",
    "templateAddTask": "Add Task via Template",
    "realTimeMeasurement": "Real-time Measurement",
    "failure": "Invalid",
    "name": "Indicator Name",
    "deleteFailed": "Delete failed.",
    "next": "Next",
    "periodTime": "Period",
    "taskInProgress": "Task in progress...",
    "revoke": "Revoke",
    "description": "Description",
    "systemCounter": "System Indicator",
    "thresholdSetting": "Threshold Settings",
    "yesterday": "Yesterday",
    "pleaseSelectResource": "Select the resource.",
    "thresholdExistUpdateOrNot": "The threshold settings already exist. Do you want to update?",
    "counterTypeName": "Measurement Object Name",
    "currentWeek": "This Week",
    "placeholder": {
      "exeCycle": "Enter the Execution cycle",
      "parameterType": "Enter the Parameter Type",
      "name": "Enter the Taske Name",
      "customs": "Enter the Customs",
      "format": "Enter the Report Generation Format",
      "startTime": "Enter the Task start Time",
      "endTime": "Enter the Task end Time",
      "neType": "Enter the NE Type",
      "space": "Enter the Space",
      "exeStep": "Enter the Execution Step"
    },
    "counterCreatePeople": "Indicator Creator",
    "hangUpEndTime": "Suspended To",
    "gnbManagement": "gnb Performance",
    "hours": "Hour",
    "previous": "Previous",
    "yes": "Yes",
    "task_opened": "Close other windows before creating a new task.",
    "selectMOplease": "Select the measurement object.",
    "managedElement": "NE Node",
    "realTimeBySeat": "Real-time Measurement Task (by position)",
    "templateType": "Template Type",
    "batchExport": "Batch Export",
    "counterManagement": "Indicator Management",
    "endCannotLaterThanTaskEnd": "The reacquisition end time cannot be later than the end time of the task.",
    "homePage": "Home",
    "seconds": "seconds",
    "addTemplate": "Add Template",
    "enable": "Enable",
    "timeRange": "Time Range",
    "calculator": "Counter",
    "atMostOneRealTask": "At most one real-time task can be created and only one task tab can be opened at a time.",
    "queryScope": "Query Criteria",
    "taskTimeRemaining": "Remaining Time",
    "activeTime": "Activation Time",
    "fail": "Failed",
    "sunday": "Sunday",
    "successInfo": "Succeeded",
    "fifteenMinutes": "15 minutes",
    "longTime": "Long Term",
    "indicatorList": "Indicator List",
    "measureTaskManagement": "Measure Task Management",
    "pleaseSelectNe": "Select resource",
    "thresholdHasSet": "Threshold set",
    "reset": "Reset",
    "performTask": "Perform Task",
    "updateMonitorTask": "Modify Task Monitor",
    "chooseCycle": "Select measurement period",
    "monthPlan": "Monthly Plan",
    "specified": "Custom",
    "addMeasureCustom": "Add Custom Measure",
    "alertIsNumberHeader": "Cannot start with a digit or a space.",
    "hangUpTask": "Suspend Task",
    "startCannotLaterThanEnd": "The start time cannot be later than the end time.",
    "thresholdNotSet": "Threshold not set",
    "alarmCreateTime": "Alarm Occurrence Time",
    "counterNameEN": "Indicator English Name",
    "startTime": "Start Time",
    "editor": "Editor",
    "nonRealTime": "Non-real Time",
    "addThreshold": "Add Threshold",
    "uploadBeginTimeError": "Incorrect start time format.",
    "endTimeNull": "End time cannot be empty.",
    "consistent": "Consistent",
    "counterCode": "Indicator ID",
    "pleaseInputAlias": "Enter the alias.",
    "quickExport": "Quick Export",
    "fillCorrectTaskDuration": "Specify the correct task duration.",
    "first": "step 1",
    "indicator": "Indicator",
    "indicatorIsOccupied": "The indicator is occupied and a new task cannot be created",
    "multiMeasureObjChart": "Multi-Measurement Object Dimension Chart",
    "measObjLdn": "Spatial Parameter Granularity",
    "kilobit": "kilobit",
    "counterNameCH": "Indicator Chinese Name",
    "taskAlreadyExists": "The task already exists.",
    "enodeb_id": "eNodeB ID",
    "threshold": "Threshold",
    "descending": "Descending",
    "startNoLagerThanEnd": "The start time cannot be later than the end time.",
    "thresholdSettingSuccess": "Thresholds set successfully",
    "queryDetailInfo": "Details",
    "resource": "Resource",
    "alertMaxLength": "Text length cannot exceed",
    "minutes": "Minute",
    "kpiChartShow": "KPI Chart Display",
    "data_bilievable": "Data Integrity",
    "searchByNe": "Search by NE name",
    "sysTemplateNoDel": "The system template cannot be deleted.",
    "counterUpdateTime": "Indicator Update Time",
    "pause": "Pause",
    "dbm": "dbm",
    "endTimeFormatError": "Incorrect end time format.",
    "importantAlarmLowerNoInclude": "Lower limit (not included)",
    "tenMinutes": "10 minutes",
    "pleaseSelectUploadBaseTime": "Select the base time.",
    "customCounterTypeName": "Custom Measure Name",
    "startCannotEarlierThanTaskStart": "The reacquisition start time cannot be earlier than the start time of the task.",
    "reportTask": {
      "taskLog": "Report Task Log",
      "parameterType": "Parameter Type",
      "hours": "Hours",
      "months": "Months",
      "weeks": "Weeks",
      "exeTaskSuccess": "Manually triggered successfully, please query on the report page.",
      "exeTask": "Manually Trigger Task",
      "format": "Report Generation Format",
      "fixedDays": "Fixed Days",
      "exeTime": "Task Statistics Deadline",
      "space": "Space Granularity",
      "exeStep": "Execution Duration",
      "exeCycle": "Execution Cycle",
      "name": "Task Name",
      "customs": "Indicator List",
      "days": "Days",
      "startTime": "Task Start Time",
      "endTime": "Task End Time",
      "neType": "NE Type"
    },
    "uploadBaseTime": "Acquisition Base Time",
    "counterName": "Indicator Name",
    "measureObjectTypeName": "Measurement Object Type Name",
    "noRealTaskManagement": "Non-real Time Task Management",
    "noRealTaskTemplateManagement": "Non-real Time Task Template Management",
    "addCustomCounter": "Add Custom Indicator",
    "alarmKpi9": "At most 9 KPIs can be shown.",
    "multiResourceChartQuery": "Query Multi-Resource Chart",
    "lowUnlimited": "Lower unlimited",
    "reportCycle": "Report Cycle",
    "indicatorFormulaText": "Indicator Formula",
    "noRealDataQuery": "Query Non-real Time Data",
    "alias": "Alias",
    "weekPlan": "Weekly Plan",
    "fillInSamplingPeriod": "Specify the measurement period.",
    "hangupTime": "Suspend Time",
    "exitTaskInfo": "Task information already exists.",
    "taskDuration": "Task Duration",
    "measureTask": "Measurement Object",
    "thresholdCanNotAllEmpty": "Thresholds cannot be all empty.",
    "clear": "Clear",
    "promptAlarmLowerNoInclude": "Lower limit (not included)",
    "uniformityCheckTime": "Check Time",
    "toastHeader": "Tip",
    "startTimeFrame": "Start Time Frame",
    "indicatorID": "Indicator ID",
    "taskEstablishTime": "Creation Time",
    "tuesday": "Tuesday",
    "templateName": "Template Name",
    "selectMSeatPlease": "Select the measurement position.",
    "task_started": "The task already exists.",
    "check_customMeasureId_tips": "Selected indicator has been referenced by the following tasks. You need to delete the task before deleting the indicator:",
    "deleteNoRealTaskWarningTips":  "After performance task is deleted, the performance data of the NE will be deleted. Are you sure to delete the selected task？",
    "targetErrorValue": "Error Value",
    "calculateKpi": "Calculate KPI",
    "taskTemplate":{
      "tmplId": "Template ID",
      "tmplName": "Template Name",
      "neType": "NE Type",
      "neVersion": "NE Version",
      "measureCycle": "Sampling Period",
      "taskNameRule": "Task Name Rule",
      "taskNamePrefix": "Task Name Prefix",
      "tmplDepict": "Task Description",
      "tmplStatus": "Template Status",
      "tmplEditTime": "Edit Time",
      "tmplEditPeople": "Editor",
      "initMeterStatus": "Initial Task Status",
      "effectiveTimeMode": "Task Time Mode",
      "meterBegTime": "Task Start Time",
      "meterEndTime": "Task Stop Time",
      "baseStationName": "NE Name",
      "baseStationId": "NE ID",
      "baseStationIpPlusPort": "NE Ip + Port",
      "selectedTmplEnable": "Are you sure you want to enable it ? ",
      "selectedTmplDisable": "Are you sure you want to disable it ? ",
      "createTaskTemplate": "Create Task Template",
      "updateTaskTemplate": "Edit Task Template",
      "showTaskTemplate": "Show Task Template",
      "taskTemplateTitle": "Task Template",
      "delTaskTemplate": "Delete Task Template",

    },
  },
  "subscriber": {
    "epcDelProfile": "Delete Profile"
  },
  "MR": {
    "deleteTaskSuccess": "Task deleted successfully",
    "neName": "Resource Name",
    "deleteTaskToorBar": "Delete Task",
    "samplePeriod": "MR Sampling Period",
    "neIp": "Resource Port",
    "neVersion": "Resource Version",
    "uploadPeriod": "MR Acquisition Period",
    "prbNum": "Subframe PRB",
    "enableTaskToorBar": "Enable Task",
    "enable": "Enable",
    "pleaseSelectNE": "Select an NE.",
    "alias": "Alias",
    "addTaskSuccess": "Task created successfully",
    "omcName": "OMC-R Name",
    "mrTaskManage": "MR Measurement Task Management",
    "sampleBeginTime": "Start Time",
    "noNull": "Alias",
    "disableTaskToorBar": "Disable Task",
    "measureType": "MR File Type",
    "timeFormatError": "Incorrect format of base time.",
    "addMrTask": "Add MR Measurement Task",
    "sampleEndTime": "Stop Time",
    "nePort": "Resource Port",
    "addTaskToorBar": "Add Task",
    "subFrameNum": "Number of Subframes",
    "disable": "Disable",
    "setTaskStatusSuccess": "Task status set successfully",
    "mrManage": "MR Management",
    "enableStatus": "Task Status"
  },
  "Pui": {
    "addPuiSuccess": "PUI added successfully.",
    "pui": "PUI",
    "delPuiSuccess": "PUI deleted successfully.",
    "authType2": "Activated",
    "forbidType1": "Forbid All Private Information",
    "cfnlStatus": "CFNL Status",
    "forbidType0": "Forbid Specific Identification",
    "puiList": "PUI List",
    "oirTemporarySet": "OIR Temporary Settings",
    "authType0": "Unauthorized",
    "authType1": "Authorized",
    "addPui": "Add PUI",
    "oipStatus": "OIP Status",
    "cfnrStatus": "CFNR Status",
    "cfuStatus": "CFU Status",
    "cfbPui": "CFB PUI",
    "pvi": "PVI",
    "cfnrTime": "CFNR Time",
    "modPuiSuccess": "PUI modified successfully.",
    "cfbPuiNull": "CFB number cannot be empty.",
    "oirStatus": "OIR Status",
    "cfnlPuiNull": "CFNL number cannot be empty.",
    "cfnrPuiNull": "CFNR number cannot be empty.",
    "modeType1": "Temporary Mode",
    "holdStatus": "Hold Status",
    "cfnlPui": "CFNL PUI",
    "ocbStatus": "OCB Status",
    "cfbStatus": "CFB Status",
    "modeType0": "Fixed Mode",
    "oirRestrictMode": "OIR Restrict Mode",
    "cfuPuiNull": "CFU number cannot be empty.",
    "cfnrPui": "CFNR PUI",
    "oipOverried": "OIP Override",
    "cwStatus": "CW Status",
    "showType0": "Default display not forbidden",
    "showType1": "Default display forbidden",
    "thirdPartyStatus": "Third-party Call Status",
    "crumb": "Subscriber/VoNR Management/PUI Template",
    "addBatchPui": "Batch Add PUI",
    "cwNotify": "CW Notify",
    "icbStatus": "ICB Status",
    "cwNotifyType1": "Do not notify",
    "modPui": "Modify PUI",
    "puiSearch": "Enter PUI to search",
    "cwNotifyType0": "Notify",
    "oirMode": "OIR Mode",
    "cfuPui": "CFU PUI",
    "cfnrcPui": "CFNRc Number",
    "cfnrcStatus": "CFNRc Subscription Status",
    "confStatus": "Conference Status",
    "qryPuiSuccess": "PUI queried successfully."
  },
  "Snssai": {
    "profileName": "Template Name",
    "dnnProfileList": "DNN Template",
    "addProfile": "Add S-NSSAI Template",
    "modProfileSuccess": "S-NSSAI template modified successfully.",
    "dnnProfile": "Associated DNN Template ID",
    "addProfileSuccess": "S-NSSAI template added successfully.",
    "qryProfileSuccess": "S-NSSAI template queried successfully.",
    "modProfile": "Modify S-NSSAI Template",
    "delProfileSuccess": "S-NSSAI template deleted successfully.",
    "sd": "SD",
    "dnnProfileName": "DNN Name",
    "crumb": "Subscriber/UDM Management/S-NSSAI Template",
    "sst": "SST",
    "profileId": "S-NSSAI Template ID"
  },
  "Login": {
    "copyright": "EULA",
    "kaptcha": "Verification Code",
    "footer": {
      "copyright": "It is recommended to use Google Chrome 71 or later with a resolution of 1920 * 1080."
    },
    "firstLogin": "Change the password on first login.",
    "title": "UNMS",
    "login": "Login",
    "uploadListLicense": "Batch uploading licenses",
    "updPasswdTitle": "Change Password",
    "license": "License",
    "password": "Password",
    "kaptchaError": "Verification code loading error.",
    "failure": "Failed",
    "uploadLicense": "Upload License File",
    "Iplimit": "Client IP Limit",
    "pwdExpired": "Password has expired.",
    "loginExpired": "This account has been locked because you have not logged in to the system for a long time. Contact the administrator to unlock the account.",
    "unlock": "Unlock",
    "unlocked": "The timeout status of this account is normal, and you do not need to unlock it.",
    "forceLoginTitle": "Login Prompt",
    "copyrightInfo": {
      "line13": "No distribution or transfer: You shall not and you agree not to, or to enable others to, sale, distribute, lease, rent, sublicense or assign any rights of this Software, or copy this Software.",
      "line14": "1.5 Governing Law",
      "line11": "No use in non-design purposes: You shall not and you agree not to, or to enable others to, install or use this Software for any non-design purposes.",
      "line12": "No reverse-engineering: You shall not and you agree not to, or to enable others to, reverse-engineer or de-compile the source codes of this Software, or discover the source code of this Software in other approaches.",
      "line10": "No modification: You shall not and you agree not to, or to enable others to, modify, translate or adapt this Software except to the extent you may be expressly permitted.",
      "line19": "The foregoing limitations and exclusions apply to the extent permitted by applicable laws in your jurisdiction. Some jurisdictions do not allow the limitation of liability. In such case, claims shall not be waived in accordance with consumer protection laws or other applicable laws.",
      "line3": "The \"Software\" means the computer program and documentation accompanying this software, provided by the Hytera Communications Co., Ltd. (\"Hytera\"), including but not limited to: i) source codes, executable codes, interfaces; ii) relevant explanatory materials or files; iii) software updates and patches; and iv) data and database. The \"use\" or \"using\" of this Software means to access, download, install, copy or otherwise benefit from using this Software.",
      "line17": "THIS SOFTWARE IS PROVIDED \"AS IS\", HYTERA DOES NOT WARRANT THE SOFTWARE CAN OR CAN NOT FULLY MEET YOUR REQUIREMENTS. USER MANUAL, HELP FILES, INTRODUCTORY MANUAL AND SOFTWARE DOCUMENTATION ARE FOR YOUR REFERENCE ONLY AND SHALL NOT BE CONSTRUED AS ANY COMMITMENTS MADE BY HYTERA.",
      "line2": "1.1 Definitions",
      "line18": "To the maximum extent permitted by applicable law, Hytera and its suppliers shall be held harmless and compensated from any and all damages, arising out of use of or incapability of using the Software, including but not limited to profit loss, business interruption, confidentiality disclosure, data/code damage,  program error and intellectual property right infringement arose by a third party, even though Hytera has been advised of such possible damages in advance.",
      "line1": "IMPORTANT: Please carefully read this End User License Agreement (\"Agreement\") before using this software or any future update to this software. By using this software or any future update to this software, you are agreeing to be bound to terms of this Agreement. If you do not agree to any term of this Agreement, please do not use this software or any future update to this software.",
      "line15": "This Agreement shall be governed by and construed in accordance with laws in PRC. Any dispute or claim arising under or relating to this Agreement shall be brought exclusively in the court in Shenzhen, China. In case of infringement of Hytera’s intellectual property rights, Hytera shall take appropriate legal actions and seek appropriate legal remedies in any competent court without restriction against the infringing party.",
      "line16": "1.6 Limitation of Liability",
      "line7": "1.3 Software License",
      "line6": "The Software may use third-party software or technology (including the open source code and public domain code that may be used for the Software). If any third-party software or technology is adopted for the Software, Hytera will demonstrate relevant agreements or other documents in accordance with relevant laws and regulations through annexes of this Agreement, a package in a specific folder of the installation package of the Software, or open source software pages and other forms. The copyright, property rights and other intellectual property rights of any third-party’s software or technology used in the Software belong to the original developer.",
      "line5": "Hytera retains the copyright, property rights and other intellectual property rights of this Software. The Software is protected by intellectual property laws, including but not limited to copyright laws, and other applicable laws. \"Hytera\", \"HYT\" and “海能达” are the trademarks or registered trademarks of Hytera in PRC and/or other countries or areas. Hytera retains the ownership of its trademarks and product names. Hytera reserves all rights not expressly granted to you.",
      "line4": "1.2 Intellectual Property Rights",
      "line9": "1.4 Restrictions on Use",
      "line8": "Before using this software, you should obtain the license for this software from Hytera or a third party authorized by Hytera by paying the licensing fee or any other fees. This Software shall only be used in conjunction with Hytera products or services and in the method that is expressly authorized by Hytera. Any use of the Software not for Hytera products or services, or beyond authorized method or scope is strictly prohibited. If you breach any material term of this Agreement, your right and license to use this Software under this Agreement will be automatically terminated. Hytera reserves all rights to the damages arose from the unauthorized use.",
      "line24": "1.9 Miscellaneous",
      "line25": "This Agreement shall not prejudice the legal rights of any party dealing as a consumer. As a legal agreement between you and Hytera, this Agreement shall supersede any and all prior representations, discussions, commitments, communications or publicity with regard to this Software.",
      "line22": "1.8 Termination",
      "line23": "This Agreement is effective until terminated. Your rights hereunder will terminate automatically without notice from Hytera if you fail to comply with any term of this Agreement. Upon termination of this Agreement, you shall immediately cease all use of the Software and destroy all copies, full or partial, of this Software.",
      "line20": "1.7 Amendment",
      "line21": "If any provision of this Agreement is held invalid or unenforceable under applicable law, it shall not affect the validity or enforceability of the reminder of the terms of this Agreement. This Agreement may not be amended or supplemented without prior authorization of Hytera.",
      "line26": "If you may have any question regarding this Agreement or may encounter any problem, please contact us by visiting the website at: http://www.hytera.com."
    },
    "username": "User name"
  },
  "LteUser": {
    "pleaseSelectDatas": "Select an item.",
    "cancel": "Cancel",
    "pdnProfileList": "Associated PDN Profile",
    "batchAddUserTip": "Mass Create",
    "addUser": "Create",
    "logger": "Log",
    "ipv6_addr": "IPv6 Address",
    "ODB": "ODB",
    "modUserSuccess": "Subscriber modified successfully.",
    "pdnApnName": "APN Name",
    "GRANTED": "Granted",
    "staticAddr": "Subscription Static IP Address",
    "selected": "You have selected",
    "SubnetAtLeastTwoNodes": "At least two nodes or one subnet in the subnet",
    "add": "Create",
    "item": "items",
    "nelist": "NE List",
    "atleastone": "Select at least one item.",
    "failed": "Failed",
    "addBatch": "Mass Create",
    "pleaseSelectOneData": "Select only one item.",
    "delConfirm": "Are you sure you want to delete it?",
    "atmost": "Select at most 10,000 items.",
    "imsireg": "Cannot start with 0.",
    "DISABLED": "Disabled",
    "character15": "15 characters",
    "delRange": "Delete by Range",
    "profile_id": "Subscription Profile ID",
    "success": "Succeeded",
    "staticAddrNum": "Static IP Address Quantity",
    "exceedImsi": "An IMSI exceeds 15 digits.",
    "imsi_status": "Subscription Status",
    "pdnType": "PDN Type",
    "staticAddrCount": "Static IP Address Quantity",
    "delUserSuccess": "Subscriber deleted successfully.",
    "imsi": "IMSI",
    "remove": "Delete",
    "exceedMsisdn": "An MSISDN exceeds 11 digits.",
    "search": "Search",
    "ipv4_addr": "IPv4 Address",
    "crumb": "Subscriber/LTE Management/Subscriber Management",
    "odb_1": "Roaming Access HPLMN-AP",
    "inquiry": "Inquiry",
    "odb_0": "Packet Oriented Service",
    "pleaseSelectNE": "Select an NE.",
    "removeRange": "Delete by Range",
    "msisdn": "MSISDN",
    "imsiRange": "IMSI Range",
    "length15": "The length is 15 digits.",
    "ipv4InfoCantEmpty": "IPv4 cannot be empty.",
    "configStaticIP": "Configure Static IP Address",
    "refresh": "Refresh",
    "batchDelUserTip": "Mass Delete",
    "addUserSuccess": "Subscriber added successfully.",
    "odb_3": "Roamer Access",
    "pdnProfileId": "Associated PDN Profile ID",
    "odb_2": "Roamer Access to VPLMN-AP",
    "wrong": "Error",
    "confirm": "OK",
    "modify": "Modify",
    "addBatchUser": "Mass Create",
    "imsiSearch": "Enter IMSI to search",
    "qryUserSuccess": "Subscriber queried successfully.",
    "modUser": "Modify",
    "imsi_odb": "ODB",
    "invalidnum": "Invalid integer."
  },
  "DeployManagement": {
    "mergeBigFile": "Merging, decompressing files...",
    "instanceNum": "Number of Instances",
    "editTemplate": "Modify Template",
    "backConfirm": "Are you sure you want to roll back the current service?",
    "upgradeHistory": "Upgrade History",
    "deployManagement": "Deployment",
    "uploadStatus": "Clear Status",
    "type": "Type",
    "tips_cancelUpload": "Uploading the service package. Are you sure to cancel?",
    "tips_cancelPatchUpload": "Uploading the patch package. Are you sure to cancel?",
    "upgradeStatus": "Upgrade Status",
    "getTemplateRuleJsonFailed": "Failed to get template validation rules.",
    "getingTopoInfo": "Synchronizing topology information, please wait...",
    "password": "Password",
    "productVersion": "Product Version",
    "charLimit": "Cannot exceed {0} characters.",
    "environmentName": "Environment Name",
    "deleteLoad": "Deleting...",
    "deployCount": "Deployment Quantity",
    "upgrageConfirm": "Are you sure you want to upgrade?",
    "environmentPort": "Environment Port",
    "tips_serviceListEmpty": "The service package list is empty, please check if there are packages on the server.",
    "upgradeOptTip": "Upgrade command sent successfully.",
    "deliverTypeStr": "Delivery Type",
    "backOptTip": "Rollback command sent successfully.",
    "environmentIP": "Environment IP",
    "inputPlaceholder_nename": "Enter the NE name",
    "uploadConfirmTip": "Are you sure you want to parse and upload the following packages?",
    "serverManagerment": "Service Management",
    "version": "Delivery Version",
    "masterNotDel": "Master node cannot be deleted.",
    "exist": "Yes",
    "noEmptyStart": "The name must not start with a space.",
    "fail": "Failed",
    "operate": "Operation",
    "expensionBtn": "Expand",
    "oneKeyDeployed": "One-click Deployment",
    "uploadServPackage": "Upload Service Package",
    "unUpgrade": "Cannot upgrade NE that is not deployed.",
    "nodeInfo": "Node Information",
    "detail": "Details",
    "synSuccessTime": "Synchronize Time",
    "savingDeploymentTemplate": "Saving...",
    "versionCount": "Version Quantity",
    "nodeName": "Node Name",
    "topoMaxLength": "Length cannot exceed",
    "unDeploy": "Not deployed",
    "poc": "PoC Service",
    "deviceUpgrageConfirm": "All NEs to which the service package is applied will be upgraded. Are you sure you want to continue?",
    "inputPlaceholder_netype": "Enter the NE type",
    "inputPlaceholder_version": "Enter the version",
    "installPkgPath": "Internal Package Path",
    "addingEnviroment": "Adding environment, please wait...",
    "batchUploadServPackage": "Batch Upload Service Package",
    "canNotAddK8sNode": "Cannot add node since no instance is deployed.",
    "serviceVerUpgrade": "Upgrade Service Version",
    "pkgName": "Package Name",
    "returnComfirm": "Are you sure you want to reboot?",
    "nodeDesc": "Node Description",
    "environmentConfig": "Environment Configuration",
    "runing": "In progress",
    "nameAndIPSame": "Environment name or IP must be unique.",
    "D_detail_serviceAndProcess": "Service\u0026Process ID",
    "uploadFinish": "Complete",
    "product": "Product",
    "inputNumberRange": "The input value must be between {0} and {1}.",
    "hasnotGPS": "Cannot delete without GPS.",
    "upgradeable": "Upgradeable",
    "templateConfirm": "Are you sure you want to modify the current configuration?",
    "deviceUpdate": "Upgrade",
    "changeGPS": "Change GPS",
    "patchUpgrade": "Patch Install Operation",
    "serviceType_base": "Basic",
    "bsDevice": "eNB",
    "notExist": "No",
    "connected": "Connected",
    "localVersion": "Local Version",
    "deleting": "Deleting environment, please wait...",
    "pkgExists": "Service package already exists.",
    "createTime": "Creation Time",
    "dpCopyCount": "Copy Quantity",
    "rolllbackable": "Rollbackable",
    "upgradeBtn": "Upgrade",
    "deploying": "Deploying...",
    "deployedDesc": "Instance Description",
    "deployedInstanceCount": "Number of Deployed Instances",
    "dpSoftVersion": "Deployment Version",
    "shrinkage": "Shrink",
    "deployFailure": "Deployment failed.",
    "getDeployedTemplateFailed": "Failed to obtain deployment template.",
    "mergeResult": "Merging and decompressing complete. \n Close this page and refresh the list to view the progress.",
    "rerunBtn": "Reboot",
    "exporting": "Exporting, please wait...",
    "rerunTip_nosupport_status": "Cannnot restart the NE due to its deployment status.",
    "neName": "NE Name",
    "internalIP": "Internal IP",
    "rerunTip_nosupport_ne": "The current NE does not support reboot.",
    "deliverType": "Delivery Type",
    "deviceReback": "Rollback",
    "lunchTime": "Launch Time",
    "versionTab": "All Versions",
    "unRun": "Not running",
    "selectProductVersion": "Select the product version.",
    "tips_noHasModExpansionParam": "No changeable expansion parameters for the current instance.",
    "uploading": "Uploading...\nYou can close this page without interrupting the upload process.",
    "deviceVerSwitch": "Switch Device Version",
    "nodeID": "Node ID",
    "invalidPackage": "Invalid package format.",
    "hasSamePackage": "A service package with the same name already exists",
    "hasSamePatchPackage": "A patch package with the same name already exists",
    "hasSameAdapterPackage": "A Adaptation package with the same name already exists",
    "invalidPatch": "Invalid patch format.",
    "deployButton": "Deploy",
    "upgrading": "Upgrading",
    "deployedTab": "Deployment",
    "rollbacking": "Rolling back",
    "addDpEnvironment": "Add Deployment Environment",
    "nodeIP": "Node IP",
    "expensionTip_nosupport": "The current NE does not support capacity expansion.",
    "parentNode": "Node",
    "pleaseSelSameType": "Select the same type of service.",
    "nodeType": "Node Type",
    "pleaseSelectOneData": "Select an item.",
    "noUpgradeVer": "No updates.",
    "synVersion": "Synchronize",
    "invalidInt": "Invalid integer.",
    "netypeCount": "NE Type Quantity",
    "name": "Name",
    "syncTopoInfo": "Sync Topology",
    "deletePkg": "Are you sure you want to delete the selected service package?",
    "serviceType_ser": "Service",
    "serviceVerSwitch": "Switch Service Version",
    "classify": "Class",
    "instanceName": "Instance Name",
    "deployTab": "Instances",
    "uploadProgress": "Upload Progress",
    "inputRangeIllegal": "The input value must be between 1 and 65535.",
    "saveTopoInfoFailed": "Failed to save topology information because the service package does not exist.",
    "deployed": "Deployed",
    "description": "Description",
    "delete": "Delete",
    "runEnvironment": "Running Environment",
    "AdapterManagement": "Adapter Management",
    "batchUpgrade": "Batch Upgrade",
    "rerunLoad": "Rebooting...",
    "configParams": "Configuration Parameter",
    "getDeployedTemplateTips": "Getting the deployment template, please wait...",
    "hasPkg": "Available Upgrade Package",
    "dpDeployedTemplate": "Deployment Template",
    "uploadDeployedTemplate": "Upload Deployment Template",
    "saveButton": "Save",
    "value": "Value",
    "runStatus": "Running Status",
    "searchUpgrade": "Querying the upgrade content, please wait...",
    "deployedInstance": "Deployed Instance",
    "alertRequired": "This field cannot be empty.",
    "addEnvironmentFailed": "Add failed.",
    "deployedStatus": "Clear Status",
    "userName": "User Name",
    "pleaseFileType": "The file must be an XML file.",
    "exportXml": "Export",
    "pkgVersion": "Version",
    "sysExternalIp": "External IP",
    "nooperation": "Inoperable",
    "displaySoftWareVersion": "Node Version",
    "cannotEditTemplate": "It has been deployed and cannot be modified.",
    "unRollBack": "Cannot roll back undeployed NEs.",
    "synchronization": "Synchronize",
    "pleaseSelect": "Select",
    "deployedDetail": "Deployment Details",
    "qryUpgradeInfo": "Are you sure you want to close the current page?",
    "deployedNode": "Deployment Node",
    "failedInstanceName": "Deployment failed.",
    "deployTotal": "Total Deployments",
    "batchDeployIms": "Batch Deploy IMS",
    "emptyTemplate": "Cannot deploy because the template is empty.",
    "rebackBtn": "Rollback",
    "totalServicePkg": "{0} packages in total.",
    "initStatus": "Initialization state"
  },
  "MML": {
    "cancel": "Cancel",
    "cluster": "Cluster",
    "operationCancelled": "Execution failed twice in a row, operation canceled.",
    "notValidInteger": "Enter an integer.",
    "tipFileName": "File Name Format is :",
    "backup": "Backup",
    "fileName": "File Name",
    "exeTimeOut": "Execute Time Out!",
    "upload": "Upload",
    "neOffline": "Cannot configure MML because NE {0} is offline.",
    "operateTime": "Operation Time",
    "executing": "In progress",
    "elementName": "NE Name:",
    "ue": "UE",
    "equipmentIp": "Device IP:",
    "maxBytesLength": "Max bytes is {0}.",
    "resourceCode": "Resource Code",
    "environmentName": "Environment Name：",
    "mmlCommand": "MML Command:",
    "selectFileButton": "Browse",
    "equipmentName": "Device Name:",
    "beginTime": "Start Time:",
    "moTree": "Mo Tree",
    "moName": "Mo Name",
    "notNull": "Cannot be empty.",
    "inputFileName": "Enter the file name with a txt suffix.",
    "validRange": "The valid range is {0}.",
    "history": "History",
    "execute": "Execute",
    "notValidDate": "Enter the correct date.",
    "ne": "Virtual NE",
    "cfgManagement": "Configuration Management",
    "mmlResponse": "MML Response:",
    "device": "Physical Device",
    "cfgPath": "Profile Path",
    "exeSuccess": "Successful execution!",
    "notValidDomainOrIp": "Enter the correct domain name or IPv4 address.",
    "execFailed": "Execution failed, the background is abnormal.",
    "buildMML": "Build MML",
    "mass": "Mass",
    "currentNode": "Node List",
    "selTypeAlert": "Select the recovery record.",
    "mml": "MML",
    "dangerOperTip": "Are you sure you want to continue?",
    "uploadCfgFile": "Upload Recovery",
    "instanceId": "Instance ID",
    "queryData": "Query Data",
    "selBaseAlert": "Select a EnodeB and query again.",
    "selectFile": "Select a .txt file.",
    "notValidTime": "Enter the correct time.",
    "fillAlias": "Enter the alias.",
    "recover": "Recover",
    "validateFailed": "Check failed.",
    "recoverOrBackup": "Recover/Backup",
    "deleteAll": "Delete All",
    "searchHolder": "Enter and search...",
    "recoverFail": "Configuration recovery failed.",
    "notValidIpv4": "Enter the correct IPv4 address.",
    "timeFormatError": "Incorrect format of base time.",
    "loadingTip": "Loading...",
    "batchRecover": "Batch Recover",
    "versionCheck": "Check Version",
    "selBaseTime": "Select base time.",
    "command": "Command",
    "cfgNeBackupOrRecover": "Configuration Management/NE Backup and Recovery",
    "importCfg": "Import profile",
    "subnetInfo": "Subnet Info:",
    "single": "Single",
    "confirm": "OK",
    "selOneBase": "Select at least one eNB.",
    "atMost100": "Select at most 100 items.",
    "notValidIpv6": "Enter the correct IPv6 address.",
    "noResult": "No result.",
    "endTime": "End Time:",
    "neType": "NE Type",
    "noCheck": "Select at least one item.",
    "executeTime": "Timed Execution",
    "neCfgRestoreConfirmTip": "After the configuration data is imported, the eNodeB may restart. Continue?",
    neCannotBeEmpty: 'The \'ne\' parameter cannot be empty.',
    commandlineTabName: 'Run Command',
    incorrectFormat: 'Incorrect MML command format.',
    notSupported: 'Chinese punctuation is not supported',
    errorMessage: 'Error Message',
    errorMessageTable: 'Error Message Table',
    successMessageTable: 'Success Message Table',
    spanTooLarge: 'The neId value span is too large.',
    result: 'Result',
    neGlobalParameters: 'NE Global Parameters',
    commandLineTooltip: 'You can specify a range of NE IDs separated by hyphens \'-\' in the \'ne\' field to limit the execution scope of the command, or you can separate multiple NE IDs with commas. For example: \'QRY Cell: ne=10000-10010,10011;\'',
  },
  "Common": {
    "cancel": "Cancel",
    "next": "Next",
    "import": "Batch Import",
    "waiting": "Please wait...",
    "upload": "Upload",
    "minLength": "The minimum length is",
    "save": "Save",
    "adSearch": "Advanced Search",
    "error": "Error",
    "tips": {
      "ldapAccountForbidDelete": "LDAP account forbid delete",
      "ldapAccountForbidChangePassword": "LDAP account forbid change password",
      "selectOne": "Select an item.",
      "noSelect": "No data selected.",
      "confirmForce": "Are you sure you want to force the selected users？",
      "success": "Operation succeeded.",
      "successData": "The operation succeeds. The operation takes effect after you log in again",
      "failure": "Operation failed.",
      "failureData": "The operation failed, please confirm whether the rule is in use",
      "onlyOneSelect": "Select only one item.",
      "confirmTip": "Are you sure you want to delete the selected items?"
    },
    "minValue": "The minimum number is",
    "minByteNum": "The minimum number of bytes is",
    "neOffLine": "NE {0} is offline",
    "warning": "Warning",
    "ok": "OK",
    "day": "Day",
    "export": "Export",
    "close": "Close",
    "all": "All",
    "Listupload": "Bulk uploads",
    "previous": "Previous",
    "maxValue": "The maximum number is",
    "refresh": "Refresh",
    "minute": "Minute",
    "confirm": "OK",
    "downloadFile": "Download File",
    "inputRange": "The input range is",
    "success": "Prompt",
    "information": "Information",
    "detail": "Details",
    "maxByteNum": "The maximum number of bytes is",
    "maxLength": "The maximum length is"
  },
  "ej2Components": {
    "dialog": {
      "close": "Close"
    },
    "tab": {
      "closeButtonTitle": "Close"
    },
    "pager": {
      "All": "All",
      "currentPageInfo": "Page {0}, total {1} pages",
      "pagerDropDown": "Pagesize",
      "totalItemsInfo": "({0} items)",
      "nextPageTooltip": "Next",
      "nextPagerTooltip": "Next",
      "previousPageTooltip": "Previous",
      "lastPageTooltip": "Last",
      "pagerAllDropDown": "Items",
      "previousPagerTooltip": "Previous",
      "firstPageTooltip": "Home"
    },
    "numerictextbox": {
      "decrementTitle": "Decrease",
      "incrementTitle": "Increase"
    },
    "uploader": {
      "cancel": "Cancel",
      "inProgress": "Download",
      "removedSuccessMessage": "File deleted successfully",
      "Upload": "Upload",
      "removedFailedMessage": "File cannot be deleted.",
      "uploadFailedMessage": "Upload failed.",
      "delete": "Delete File",
      "remove": "Delete",
      "Clear": "Clear",
      "Browse": "Browse",
      "readyToUploadMessage": "Preparing to upload",
      "invalidFileType": "File type not allowed",
      "dropFilesHint": "Delete",
      "uploadSuccessMessage": "Upload succeeded"
    },
    "grid": {
      "EmptyRecord": "No record found."
    },
    "daterangepicker": {
      "customRange": "Custom Range",
      "cancelText": "Cancel",
      "startLabel": "Select start date",
      "selectedDays": "Select Date",
      "days": "days",
      "placeholder": "Select date range",
      "endLabel": "Select end date",
      "applyText": "OK"
    },
    "timepicker": {
      "placeholder": "Select Time"
    },
    "dropdowns": {
      "noRecordsTemplate": "No record found.",
      "actionFailureTemplate": "Request failed."
    },
    "datepicker": {
      "today": "Today",
      "placeholder": "Select date"
    },
    "chart": {
      "ZoomOut": "Zoom Out",
      "Zoom": "Zoom",
      "Pan": "Pan",
      "Reset": "Reset",
      "ZoomIn": "Zoom In"
    },
    "datetimepicker": {
      "today": "Today",
      "placeholder": "Select date and time"
    }
  },
  "Observe": {
    "filterConditions": "Filter Conditions",
    "struct": "Structure",
    "cancel": "Cancel",
    "region": "region",
    "neId": "NE ID",
    "fileName": "File Name",
    "maximumMissionNumber": "At most 5 task tracking",
    "taskDeletion": "Delete Task",
    "resourcesList": "Resource List",
    "extBuff": "Extended Information Field",
    "publicMessage": "Public Message",
    "taskTracking": "Task Tracking",
    "serviceState": "Current Service State",
    "messageType": "Message Type",
    "reportInfo": "Information",
    "realTimeFiltering": "Real-time Filter",
    "text": "Text",
    "issued": "To be issued",
    "taskStatus": "Task Status",
    "apn": "APN",
    "taskID": "Task ID",
    "extLen": "Extended Field Length",
    "suspendTask": "Suspend Task",
    "active": "Execute",
    "downloadFile": "Download File",
    "realTime": "Real-time",
    "failTime": "Failure Report Time",
    "observeManage": "Failure Observation Management",
    "mission": "Track",
    "stop": "Pause",
    "taskName": "Task Name",
    "detail": "Details",
    "queryTrack": "Query Signaling",
    "createTask": "Create Task",
    "status": "Clear Status",
    "taskSrc": "Task Source",
    "greate": "To be executed",
    "autoActivationFailed": "Automatic activation failed.",
    "save": "Save",
    "taskList": "Task List",
    "failcode": "Failure Code",
    "pleaseNameEnterQuery": "Enter the task name to query.",
    "refreshTask": "Refresh Task",
    "addTask": "Add Task",
    "result": "Execution Result",
    "search": "Search",
    "file": "File",
    "creatTime": "Creation Time",
    "pleaseSelectNE": "Select resource.",
    "noDataToExport": "Cannot export without data",
    "taskIsPending": "Task suspended",
    "startTime": "Start Time",
    "operating": "Operation",
    "close": "Close",
    "endTimeGreaterThanStartTime": "The end time must be later than the start time.",
    "userPlaceholder": "Enter up to 10 user numbers, e.g. 460980123456788, 460980123456789",
    "historyFilter": "History Filter",
    "systemId": "System ID",
    "resourceID": "Resource ID",
    "expression": "Expression",
    "activationTask": "Activate Task",
    "userId": "User ID",
    "confirm": "OK",
    "filter": "Filter",
    "taskTypeID": "Template ID",
    "endTime": "Stop Time",
    "complete": "Done",
    "resourceType": "Resource Type",
    "callID": "Call-ID",
    "userPlaceholderHss": "Please enter the standard format (up to 10 PUI or PVI can be entered), e.g. sip:+123456@XX.com, tel:+1234567, 1234567@xx.com",
    "searchNe": "Search NE",
    "reIssued": "Reissue",
    "neName": "NE Name",
    "reportLevel": "Report Level",
    "trackingCommunity": "Tracking Area",
    "hangup": "Suspend",
    "pleaseEnterQuery": "Enter query conditions.",
    "reportType": "Report Type",
    "download": "Download",
    "duplicateContent": "Duplicate user number",
    "finish": "Done",
    "export": "Export",
    "taskDetails": "Task Details",
    "add": "Add",
    "all": "All",
    "importTrackData": "Import Signaling Data",
    "signalingDetails": "Signaling Details",
    "tracing": "In progress",
    "level": "Level",
    "attributeValues": "Field Name",
    "resourceName": "Resource Name",
    "queryError": "Query error",
    "notGenerated": "Files not generated.",
    "importFileError": "Error while importing files",
    "importFileFormatError": "Import file format error",
    "deleteTaskInfo": "Deleting a task will also delete the related report file. Do you want to delete the task?",
    "moduleNo": "Module ID",
    "success": "Succeeded",
    "monitorTrack": "Task Monitoring",
    "standardInterface": "Standard Interface",
    "activation": "Activate",
    "missionAlreadyCompleted": "Task already completed",
    "import": "Batch Import",
    "taskInProgress": "Task in progress",
    "measuringObject": "Measurement Object",
    "allUserTag": "All User Tracking Flag",
    "NElist": "NE List",
    "error": "Failed",
    "delete": "Delete",
    "pleaseSelectMeasuringObject": "Select the measurement object.",
    "signalDataExport": "Failed to export the failure observation data.",
    "attributeName": "Attribute Name",
    "reportWarning": "Warning",
    "missionCompleted": "Finish Task",
    "deleteFile": "Do you want to delete the file?",
    "userTrack": "User Tracking",
    "searchResource": "Search Resources",
    "sliceId": "NE Slice ID",
    "curRecvEvent": "Currently Received Messages",
    "userIdList": "User Tracking List",
    "implementation": "In progress",
    "failTrack": "Failure Tracking",
    "contextId": "User Context ID",
    "reportError": "Error",
    "invalidFormat": "Invalid format",
    "fieldIsRequired": "This item cannot be empty",
    "systemOutTime": "System connection timeout",
    "pleaseSelect": "Select",
    "time": "Time",
    "invalidChart": "Invalid special character",
    "internalSignaling": "Internal Signaling"
  },
  "Alarm": {
    "eqType": "EnodeB type",
    "validityTime": "Expiration time",
    "eqType_1": "commercial",
    "eqType_2": "temporary",
    "eqType_4": "debugging",
    "cancel": "Cancel",
    "pleaseEnterAlmId": "Enter event ID",
    "numberOfWarningAlarms": "Warnings",
    "notitylevel": "Severity",
    "messageNo": "SN",
    "confirmGhost": "Are you sure you want to recover?",
    "alarmNum": "Total Alarms",
    "notInput": "Cannot input",
    "rulename": "Rule Name",
    "notifyuser": "Recipient User Group",
    "alarmType_3": "Environment",
    "alarmType_2": "Business",
    "alarmType_1": "Transmit",
    "alarmType_0": "Equipment",
    "alarmSource": "Alarm Source",
    "synchronize": "Sync",
    "eventNum": "Total Events",
    "edit": "Edit",
    "syncError": "Synchronization failed.",
    "callContent": "Push Content",
    "confirmUser": "Acknowledged by",
    "xxkzinfo3": "Extended Info. 3",
    "xxkzinfo4": "Extended Info. 4",
    "xxkzinfo1": "Extended Info. 1",
    "alarmType_4": "QoS Alarm",
    "xxkzinfo2": "Extended Info. 2",
    "warnfilter": "Special Filter",
    "notValidDate": "Enter valid date",
    "syncSuccess": "Synchronization succeeded.",
    "callBackLog": "Push Log",
    "envName": "Environment Name",
    "statisticType": "Statistic Type",
    "startdatenull": "Start date cannot be empty.",
    "notificationTimeRule": "Notification Type",
    "alarmID": "Alarm ID",
    "callResult": "Push Result",
    "filteridentity": "Filter Identity",
    "byType": "By Type",
    "extraInfo": "Additional Info",
    "notityform": "Notification Type",
    "eventSubscription": "Subscribe Event",
    "notSingleQuoteOrBackslash": "Single quotes or backslashes are not allowed.",
    "notifyedit": "Edit Time",
    "equipmentType": "Device Type",
    "alarmCount": "Number of Alarms",
    "pleaseEnterAlarmName": "Enter alarm name.",
    "broadbandInquiry": "Query Alarm",
    "alarmLevel": "Alarm Level",
    "analysisAlarm": "Analysis Alarm",
    "close": "Close",
    "deployIp": "Deploy IP",
    "createtime": "Create Time",
    "callBackUrl": "Push Address",
    "refresh": "Refresh",
    "endtime": "End Date",
    "defaultThanmax": "default layer cannot be larger than maximum layer",
    "confirm": "OK",
    "createTime": "Occurrence Time",
    "cabinet": "Shelf No.",
    "inputTip": "Enter a title to search",
    "alarmDec": "Alarm Description",
    "numberOfMajorAlarms": "Major Alarms",
    "clearTime": "Clearance Time",
    "notificationTimenull": "The notification sending interval cannot be empty.",
    "currentAlarmSummary": "Current Alarm Summary",
    "thisWeek": "This week",
    "inputTipCallUrl": "Enter third-party IP address",
    "addFilterRule": "Add Filter Rule",
    "advancedSearchSetting": "Advanced Search - Condition Settings",
    "enableAlarmNoticeconfirm": "Are you sure you want to enable the selected alarm rule?",
    "eventLevel": "Event Level",
    "notificationMethodnull": "The notification form cannot be empty.",
    "redefineModigy": "Edit Redefinition",
    "equipmentName": "Device Name",
    "export": "Export",
    "exportAll": "Export all",
    "singleNetwork": "Single NE",
    "isvirtual": "Virtual ID",
    "add": "Add",
    "eventId": "Event ID",
    "alarmName": "Alarm Name",
    "eventDetails": "Event Details",
    "callLog": "Push Log",
    "success": "Succeeded",
    "inputTipCallName": "Enter the name",
    "editBlockingRule": "Edit Shielding Rule",
    "alarmDetails": "Alarm Details",
    "saveMapSuccess": "saveMapSuccess",
    "unconfirm": "Unconfirm",
    "frame": "Chassis No.",
    "thisYear": "This year",
    "subSlot": "Subslot No.",
    "hidden": "Hidden",
    "nenull": "The alarm source cannot be empty.",
    "notityinterval": "Notification Period",
    "remove": "Delete",
    "redefine": "Redefined",
    "too_many_checked": "Cannot select multiple items.",
    "minValueIs": "The minimum value is",
    "eventLog": "Event Log",
    "ghostAllSystem": "All systems are successfully reset.",
    "callBackName": "Push Name",
    "alarmOper": "Alarm Handling",
    "minThandefault": "minimum layer cannot be larger than default layer",
    "alarmSocket": "Real-time Alarm",
    "notityitem": "By Alarm Item",
    "print": "Print",
    "alarmSync": "Alarm Sync",
    "alarmSyncConfirmTip": "Are you sure you want to synchronize all alarm data?",
    "alarmSyncLoad": "synchronizing",
    "notifyUserNotExist": "The recipient user group does not exist.",
    "automaticConfirmation": "Auto Acknowledge",
    "fieldIsRequired": "This item cannot be empty.",
    "notifyUserGroup": "Recipient User Group",
    "eventCause": "Cause of Event",
    "envType": "Environment Type",
    "nodeSelect": "Select Node",
    "numberOfCriticalAlarms": "Critical Alarms",
    "EndTimeLessThanStartTime": "The end time must not be earlier than the start time.",
    "pleaseChoose": "Select",
    "confirmSettingParameter": "The selected parameter cannot be empty.",
    "neType": "NE Type",
    "noPermission": "No permission",
    "filterSetting": "Filter Settings",
    "exportSetting": "Data Export - Condition Settings",
    "starttime": "Start Date",
    "xxdwinfo1": "Alarm Info. 1",
    "xxdwinfo2": "Alarm Info. 2",
    "blockingRule": "Shielding Rule",
    "showSetting": "Alarm Show Settings",
    "sysDescription": "System Description",
    "clearType": "Clearance Type",
    "thisMonth": "This Month",
    "unenableAlarmNoticeconfirm": "Are you sure you want to disable the selected alarm rule?",
    "editRules": "Edit Rule",
    "restoration": "Reset",
    "no_checked": "No data selected.",
    "unenableconfirm": "Are you sure you want to disable the selected shielding rule?",
    "repeatVersion": "Please select the same version of EnodeB for import validation",
    "alarmHidden_16": "Acknowledged",
    "alarmHidden_15": "Occurrence Time",
    "alertSubscription": "Subscribe Alarm",
    "alarmHidden_18": "Acknowledged by",
    "virtualNet": "Virtual NE",
    "pleaseEnterTheQueryCriteria": "Alarm ID/Description/AlarmName/Acknowledged by",
    "alarmHidden_17": "Acknowledgement Time",
    "alarmHidden_12": "Environment Name",
    "alarmHidden_11": "Environment Type",
    "confirmTime": "Acknowledgement Time",
    "alarmHidden_14": "Virtual ID",
    "alarmHidden_13": "Alarm Location",
    "eventType": "Event Type",
    "numberOfMinorAlarms": "Minor Alarms",
    "alarmHidden_10": "NE IP",
    "alarmClearStatus_0": "Uncleared",
    "notificationRuleName": "Notification Rule Name",
    "realTime": "Real-time",
    "isOpen": "Whether to enable",
    "callFail": "Push failed.",
    "pleaseSelectNe": "Select NE",
    "alarmLevelnull": "The alarm level cannot be empty.",
    "alarmUpdate": "Update Alarm",
    "brdType": "Board Type",
    "topAlarm": "Top Alarm",
    "status": "Status",
    "shield": "Shield",
    "statisticType_0": "All Net",
    "periodic": "Periodic",
    "statisticType_1": "Sub Net",
    "statisticType_2": "NE",
    "eventSource": "Event Source",
    "alarmClearStatus_1": "Cleared",
    "editFilterRule": "Edit Filter Rule",
    "physics": "Physical NE",
    "datevalidate": "End date should be later than start date.",
    "totalNumberOfAlarms": "Total Alarms",
    "logId": "Log ID",
    "event": "Event",
    "manul": "Manual",
    "alarmHidden_2": "Alarm Name",
    "alarmHidden_3": "Alarm Level",
    "alarmHidden_1": "Alarm ID",
    "confirmSetting": "Auto Acknowledge Settings",
    "neSelect": "Select NE",
    "notifytemplate1": "Template 1",
    "notifytemplate2": "Template 2",
    "notInputblank": "Spaces not allowed",
    "filter": "Filter",
    "modifiedSystemFailed": "This alarm is not allowed to be modified",
    "addRules": "Add Rule",
    "disable": "Disable",
    "able": "Enable",
    "alarmHidden_8": "Device Name",
    "enddatenull": "End date cannot be empty.",
    "alarmHidden_9": "Device ID",
    "alarmHidden_6": "NE Name",
    "alarmHidden_7": "Device Type",
    "alarmHidden_4": "Alarm Type",
    "historyAlarm": "History Alarm",
    "alarmStatistics": "AlarmStatistics",
    "statistics": "Statistics",
    "alarmHidden_5": "NE Type",
    "confirmCycle": "Acknowledge Cycle",
    "pleaseSelectEndTime": "Select end time",
    "auto": "Auto",
    "notifystart": "Start Time",
    "advancedSearch": "Advanced Search",
    "byName": "By Name",
    "eventDes": "Event Description",
    "neName": "NE Name",
    "alarmConfirmStatus_1": "Yes",
    "alarmConfirmStatus_0": "No",
    "addBlockingRule": "Add Shielding Rule",
    "insideAlarmNotAllowShield": "The alarm by the UNMS itself does not support shielded.",
    "unconfirm_unconfirm": "Failed. The alarm is unacknowledged.",
    "callTitle": "Push Title",
    "day": "day",
    "deployIpId": "Device ID",
    "pleaseSelectStartTime": "Select start time",
    "notifyend": "Stop Time",
    "neEventFDN": "Event Location",
    "maxValueIs": "The maximum value is",
    "alarmDeleteConfirm": "Are you sure you want to delete it?",
    "additionInfo": "Additional Info",
    "alarmStatus": "Alarm Status",
    "currentAlarm": "Current Alarm",
    "alarmnull": "The alarm information cannot be empty.",
    "maxLength": "Text length cannot exceed",
    "alarmredefned_3": "Redefine Severity/Redefine Description",
    "unclearedDuration": "Uncleared Duration（s）",
    "enablewarnfilter": "Are you sure you want to enable the selected filter rule?",
    "alarmredefned_4": "Redefine Suggestion",
    "alarmNotice": "Alarm Notification",
    "alarmredefned_5": "Redefine Suggestion/Redefine Severity",
    "alarmredefned_6": "Redefine Suggestion/Redefine Description",
    "sysType": "System Type",
    "alarmredefned_7": "Redefine Suggestion/Redefine Description/Redefine Severity",
    "callBack": "Alarm Push",
    "cause": "Cause of Alarm",
    "remark": "Description",
    "slot": "Slot No.",
    "error": "Failed",
    "subnetName": "Subnet Name",
    "alarmAynchronize": "Sync Alarm",
    "eventAynchronize": "Sync Event",
    "hour": "hour",
    "minThanmax": "minimum layer cannot be larger than maximum layer",
    "methodToInforme": "Notification Form",
    "callSuccess": "Push succeeded",
    "advise": "Suggestion",
    "alarmManage": "Alarm",
    "alarm": "Alarm",
    "alreadyModifiedSystem": "All systems modified successfully.",
    "thisDay": "Today",
    "notInteger": "Enter valid integer",
    "alarmRedirect": "Redefine Alarm",
    "fhostSystemFailed": "Failed to reset system.",
    "clear": "Clear",
    "confirmState": "Acknowledged",
    "neAlarmFDN": "Alarm Location",
    "clearState": "Clear Status",
    "enableconfirm": "Are you sure you want to enable the selected shielding rule?",
    "minute": "minute",
    "alarmType": "Alarm Type",
    "unenablewarnfilter": "Are you sure you want to disable the selected filter rule?",
    "acknowledge": "Acknowledge",
    "clearUser": "Cleared by",
    "filterRule": "Filter Rule",
    "indicatorThreshold": "Indicator alarm threshold",
    "alarmLevel_1": "Major",
    "notifytemplate": "Notification Template",
    "alarmLevel_0": "Critical",
    "alarmredefned_1": "Redefine Severity",
    "alarmLevel_3": "Warning",
    "callTime": "Push Time",
    "alarmredefned_2": "Redefine Description",
    "alarmLevel_2": "Minor",
    "addIndicatorAlarmThreshold": "Add Indicator Alarm Threshold",
    "modifyIndicatorAlarmThreshold": "Modify Indicator Alarm Threshold",
    "addBusyTimeIndicatorAlarmThreshold": "Add Time Range of Indicator Alarm",
    "modifyBusyTimeIndicatorAlarmThreshold": "Modify Time Range of Indicator Alarm",
    "upperLimitOfTheBusyTimeThreshold": "Upper Limit of The Busy Time Threshold",
    "lowerLimitOfTheBusyTimeThreshold": "Lower Limit of The Busy Time Threshold",
    "upperLimitOfTheIdelTimeThreshold": "Upper Limit of The Idle Time Threshold",
    "lowerLimitOfTheIdelTimeThreshold": "Lower Limit of The Idle Time Threshold",
    "setTheBusyHourTimeRangeTips": "Click button to add a busy time range, Which is the local time of the enodeb",
    "dateRange": "Date Range",
    "K0000020030": "RRC Establishment Success Rate",
    "K0000020031": "S1 Signal Connection Establishment Success Rate",
    "K0000020032": "Initial E-RAB Setup Success Rate",
    "K0000020052": "Additional E-RAB Setup Success Rate",
    "K0000020062": "E-RAB Setup Success Rate upon Incoming Handover",
    "K0000020051": "E-RAB Abnormal Release Rate",
    "K0000020092": "Voice service Setup Success Rate (QCI=1)",
    "K0000020093": "Data service Setup Success Rate (QCI=8,9)",
    "K0000020074": "Session Setup Success Rate",
    "K0000020174": "Success Rate of Intra-eNB Intra-frequency Outgoing Handover",
    "K0000020175": "Success Rate of Intra-eNB Intra-frequency Incoming Handover",
    "K0000020180": "Success Rate of Intra-eNB Inter-frequency Outgoing Handover",
    "K0000020181": "Success Rate of Intra-eNB Inter-frequency Incoming Handover",
    "K0000020172": "Success Rate of Inter-eNB Intra-frequency Outgoing Handover via X2",
    "K0000020173": "Success Rate of Inter-eNB Intra-frequency Incoming Handover via X2",
    "K0000020178": "Success Rate of Inter-eNB Inter-frequency Outgoing Handover via X2",
    "K0000020179": "Success Rate of Inter-eNB Inter-frequency Incoming Handover via X2",
    "K0000020170": "Success Rate of Inter-eNB Intra-frequency Outgoing Handover via S1",
    "K0000020171": "Success Rate of Inter-eNB Intra-frequency Incoming Handover via S1",
    "K0000020176": "Success Rate of Inter-eNB Inter-frequency Outgoing Handover via S1",
    "K0000020177": "Success Rate of Inter-eNB Inter-frequency Incoming Handover via S1",
    "buiInterfaceLicenseDisable": "The NBI interface license has been set disable!The synchronization operation cannot be performed!",
    "theLowerLimitValueShouldNotBeHigherThanTheUpperLimitValue": "The upper limit value should be higher than the lower limit value",
    "pleaseAddTimePeriod": "Please add time period",
    "youCanAddAMaximumFfFiveTimeSegments": "You can add a maximum of five time segments",
    "TheTimeRangesOverlapResetTheTimeRanges": "The time ranges overlap, Reset the time ranges",
    "theDeviceIsOccupied": "The device is occupied, Please select another device",
    "moreThanMaxConcurrentExportNum": "The maximum number of concurrent exports exceeded. Procedure",
    "moreThanMaxExportDetailNum": "The number of exported details exceeded the maximum. Procedure",
    "resultCountIsZero": "The number of query results is zero",
    "systemMonitorTaskExceedsTheSpecifiedThreshold": "The CPU or memory threshold of a system monitoring task exceeds the specified threshold",
    "NbiSwitchDisable": "The northbound interface licence is configured to 'Not Available'!",
    "ruleExpired":"Rule has expired"
  },
  "Software": {
    "cancel": "Cancel",
    "appupdate": "APP Management",
    "bak_fail": "Switch failed.",
    "updateBSMax": "Up to 100 BS can be upgraded at the same time",
    "updatePatchBSMax": "Up to 100 BS can be upgraded at the same time",
    "pkgType": "Package Type",
    "upload": "Upload",
    "dataUpload": "Upload",
    "partSucc": "Partially succeeded",
    "endipaddr": "End IP Address",
    "selectDeviceGrp": "Select device group.",
    "td_taskType": "Task Type",
    "tips_cancelUpload": "Uploading the upgrade package, are you sure you want to cancel?",
    "import_DHCP_error": "Please check if the data you want to add already exists.",
    "import_DHCP_error1": "Please add neId network elements to the Device list first.",
    "import_DHCP_error2": "DHCP data upload failed.",
    "softManage_Lib": "Software/Repository management",
    "upda_fail": "Upgrade failed.",
    "upgrademanage": "Upgrade Management",
    "td_progress": "Progress",
    "enterKeywordSearch": "Enter NE name to search",
    "downloadSuccess": "Download succeeded",
    "softManage_Automantic": "Software/DHCP",
    "no_checked": "No item selected.",
    "exportdata": "Export Data",
    "exportTemplateTip": "Are you sure you want to export window template？",
    "td_operationType": "Operation Type",
    "td_createTime": "Creation Time",
    "onlyReserveAllowed": "You can only activate the version whose version package is in the standby state.",
    "pleaseEnterTheQueryCriteria": "Enter the query criteria.",
    "active": "Activate",
    "patch_uninstall":"Patch Uninstall",
    "patch_delete":"Patch Delete",
    "patch_fall_back":"Patch Fall Back",
    "POCUpgrade": "Upload MPTT",
    "downloadFailure": "Not downloaded",
    "uploaderStr": "Uploader",
    "softManage_AppUpgrade": "System/APP Management",
    "fail": "Failed",
    "dl_succ": "Download succeeded",
    "reserved": "Reserved",
    "pleaseSelectNe": "Select an NE.",
    "td_pkgStatus": "Package Status",
    "selectOprObj": "Select an object",
    "uploadExcel": "Upload",
    "addtask": "Add Upgrade Task",
    "versiondescription": "Version Description",
    "DlandAt": "Push;Activate",
    "td_neName": "Device Type",
    "waitforexe": "Pending",
    "dl_noneed": "No need to download",
    "pocupgrade": "PoC Upgrade",
    "messionExist": "An ongoing task already exists.",
    "DHCPIsLoading": "Loading DHCP data...",
    "updManage": "Upgrade Management",
    "selectDevice": "Select a device",
    "save": "Save",
    "que_version": "Software/Repository Query",
    "distributionState": "Allocation Status",
    "notifystatus": "Notification Status",
    "uploader": "Uploader",
    "query_frameId": "Chassis No.",
    "deviceNotExistInfo": "No device to upgrade.",
    "runversion": "Running Version",
    "storeversion": "Stored Version",
    "close": "Close",
    "caution": "The device will restart if you select activate. Are you sure you want to continue?",
    "cautionPatchBack": "Note: Select \"Patch Uninstall\" and \"Patch Fallback\" and the device will restart.",
    "informed": "Notified",
    "rollback": "Switch",
    "queryAppSoftwareInfo": "Query APP Info",
    "queVersion": "Querying the version",
    "vmyes": "Yes",
    "td_packageName": "Upgrade Package Name",
    "patchName": "Patch Name",
    "zipTag": "Patch Tag",
    "patchMadeTime": "Upload Time",
    "td_executionTime": "Execution Time",
    "td_finishTime": "Finish Time",
    "refresh": "Refresh",
    "Uploading": "Uploading the file...",
    "deleteTip": "Are you sure you want to delete it? It cannot be recovered after deletion.",
    "selectOprType": "Select operation type",
    "selectOprTypePatch": "Only one can be selected for uninstall and fallback!",
    "query_cabinetId": "Shelf No.",
    "ExecuteFile": "Executable File",
    "filter": "Filter",
    "Searching": "Querying...",
    "startipaddr": "Start IP Address",
    "downloadstatus": "Download Status",
    "AddPOCVersion": "Upload MPTT Package",
    "td_result": "Result",
    "tdMML_result": "MML Result",
    "tdPatch_result": "Patch Result",
    "pleaseUploadFile": "Upload the file.",
    "validateInputInfo": "The input data is wrong, please check it.",
    "devicegroupname": "Device Group Name",
    "notstart": "Not started",
    "up_fail": "Upload failed.",
    "query_appVersion": "Application Version",
    "DlandAtandUl": "Push;Activate;Upload",
    "selectPkg": "Select the upgrade package.",
    "versionName": "Version Name",
    "enterKeywordSearchDevice": "Enter the device name to search",
    "vmno": "No",
    "backcaution": "The device will restart. Are you sure you want to continue?",
    "exporttemplate": "Export Template",
    "updataOper": "Operation",
    "updataOperPatch": "Patch fallback operation",
    "download": "Push",
    "td_status": "Status",
    "downloading": "Downloading",
    "query_remarks": "Description",
    "versionNo": "Version Number",
    "export": "Export",
    "subnetmask": "Subnet Mask",
    "opetask": "Operation Task",
    "add": "Add",
    "lte_udp_version": "Repository Upgrade",
    "lte_patch_version": "Patch Install",
    "lte_patch_length_alert": "Patch packs cannot exceed 20",
    "lte_pkg_length_alert": "Upgrade packs cannot exceed 10",
    "rb_version": "Version Rollback",
    "rb_patch_version":"Patch rollback delete",
    "serialNumber": "ESN",
    "td_isSupportRbk": "Support Switch",
    "softManage_Upd": "Software/Repository Upgrade",
    "softManage_patch": "Device Management/Patch Install",
    "ipAddress": "IP Address",
    "AtandUl": "Activate;Upload",
    "done": "Finished",
    "MCSUpgrade": "Upload MCC",
    "pkgMode": "Package Mode",
    "query_slotId": "Slot No.",
    "nename": "NE Name",
    "success": "Succeeded",
    "selectAtLeastOne": "Select at least one item.",
    "nonallocated": "Unallocated",
    "dl_already": "Existing",
    "td_packageTag": "Package Tag",
    "import": "Batch Import",
    "netask": "Device Task",
    "td_taskId": "Task ID",
    "description": "Description",
    "td_fileName": "File Name",
    "td_mainPkgVer": "Baseline Version Number",
    "redo": "Redo",
    "keySerach": "Enter a keyword to search.",
    "td_packageVer": "Version Number",
    "delete": "Delete",
    "dataIsLoading": "Loading data...",
    "running": "In progress",
    "dl_fail": "Download failed.",
    "td_detail": "Details",
    "common": "Common",
    "too_many_checked": "Cannot select multiple items.",
    "rollbackOper": "Rollback",
    "DlandUl": "Push;Upload",
    "softManage_back": "Software/Version Rollback",
    "MD5Code": "MD5",
    "allocated": "Allocated",
    "uploadtime": "Upload Time",
    "td_neID": "Device Name",
    "progressing": "In progress",
    "downloadtasklist": "Download Task List",
    "AddMCSVersion": "Upload MCC Package",
    "addRollbacktask": "Add Rollback Task",
    "td_isSupportMS": "Support Redundancy",
    "tscipautodistribute": "DHCP",
    "pkgMadeTime": "Version Package Creation Time",
    "MD5CheckFail": "MD5 check failed.",
    "RequiredLength": "The length of input data should be",
    "unInformed": "Not notified",
    "uploadTpkg": "Upload Upgrade Package",
    "RbandUl": "Switch;Upload",
    "PatchUninstall": "Patch Uninstall",
    "PatchFallback": "Patch Fallback",
    "patchPush":"Push",
    "patchActive":"Active",
    "patchPushActive":"Push;Active",
    "gateway": "Gateway",
    "pleaseEnterDevicegroupname": "Enter Device Group Name",
  },
  "dhcpEmsVlan":{
    "neId": "Ne Id",
    "esn": "Esn Code",
    "vlan_id": "Vlan Id",
    "is_assign":"Whether to allocate",
    "status_success":"Allocated",
    "status_failed":"Unallocated",
    "ip": "Ip",
    "subnet_mask": "Subnet Mask",
  },
  "NSMF": {
    "shareable": "Shareable",
    "sliceNum": "Total Number of Slices",
    "instance": "Instantiate",
    "downlinkName": "Downlink Throughput",
    "amfShareNe": "Sharable AMFs",
    "shareNe": "Share NE",
    "nsmfThroughput": "Throughput",
    "deleteNSI": "Do you want to delete this network slice instance?",
    "nsmfUsed": "Used",
    "nsmfVersionNum": "Version Number",
    "nsmfNotUsed": "Not Used",
    "sdRepeat": "Duplicate SD",
    "mcc": "MCC",
    "nsmfAppIntroduction": "App Introduction",
    "deployinfo": "Fill in the deployment information of the selected NE.",
    "udmShareNe": "Sharable UDMs",
    "createServiceProfile": "Add Slice Profile",
    "deactivate": "Pause",
    "pleaseEnterQuery": "Enter query conditions.",
    "aliasNoEmpty": "Alias ​​cannot be empty.",
    "gbpsRangeIllegal": "The input value must be between 1 and 20.",
    "nsmfPhysical": "Physical Resources",
    "sst": "SST",
    "administrativeState": "Status",
    "deleteSliceProfile": "Do you want to delete this network slice subnet profile?",
    "neDeploy": "NE Configuration",
    "cfgExport": "Config Import and Export",
    "checkParam": "Consistency Check",
    "add": "Add",
    "addInstanceLoading": "Deploying, please wait...",
    "deactivateNSSIInfo": "Do you want to deactivate this network slice?",
    "sstRepeat": "Duplicate SST",
    "activateNSSIInfo": "Do you want to activate this network slice?",
    "deleteNSSI": "Do you want to delete this network slice subnet instance?",
    "gbps": "Throughput",
    "oamMore": "OAM One-to-Many",
    "runMode": "Run Mode",
    "nsmfMemory": "Memory",
    "nsmfNember": "Number of Online Users",
    "activateNSIInfo": "Do you want to activate this network slice?",
    "success": "Succeeded",
    "numberRangeIllegal": "The input value must be between 1 and 10000.",
    "activate": "Activate",
    "name": "Template Name",
    "nsmfAlias": "Alias:",
    "disableSend": "Check at least one NE and fill in the information.",
    "serviceProfile": "Network Slice Template",
    "selectSliceProfile": "Select a subnet profile.",
    "ipNoEmpty": "IP cannot be empty",
    "deleteServiceProfile": "Do you want to delete this network slice profile?",
    "instanceName": "Slice Instance Name",
    "nsi": "Network Slice Instance",
    "inputRangeIllegal": "The input value must be between 1 and 16777215.",
    "latency": "Latency",
    "administrativeState0": "Deactivated",
    "sliceProfile": "Slice Subnet Profile",
    "administrativeState1": "Activated",
    "envChoice": "Select Environment",
    "delete": "Delete",
    "ipCheck": "Invalid IP",
    "caps": "Number of User Sessions",
    "sd": "SD",
    "gnbNumRangeIllegal": "The input value must be between 1 and 128.",
    "gnbNum": "Number of BSs",
    "nsmfShelfTime": "Launch Time",
    "amfDeployNum": "Number of Deployed AMFs",
    "udmShare": "UDM Share Attribute",
    "disableShare": "Unshareable",
    "nsmfMonitor": "NSMF Monitor",
    "nsmfDeliveryType": "Delivery Type",
    "sstSdRepeat": "The combination of SST and SD must be unique.",
    "shareProperty": "Share Property",
    "mnc": "MNC",
    "serviceProfileId": "Associated Slice Profile",
    "nsmfDescription": "Description:",
    "maxNumberofUEs": "Number of UEs",
    "maxMumberOfUe": "Max. Number of Users",
    "nsmfBusiness": "Business Resources",
    "nssi": "Network Slice Subnet Instance",
    "refresh": "Refresh",
    "nok8sNode": "No node selected",
    "monitor": "Monitor",
    "upfDeployNum": "Number of Deployed UPFs",
    "createSliceProfile": "Add Slice Subnet Profile",
    "uplinkName": "Uplink Throughput",
    "amfShare": "AMF Share Attribute",
    "deactivateNSIInfo": "Do you want to deactivate this network slice?",
    "sharePropertyNe": "Shareable NEs",
    "nsmfCpu": "CPU",
    "nsmfManage": "Network Slice Management",
    "instanceSliceProfileName": "Slice Subnet Instance Name",
    "namespace": "Namespace",
    "validChart": "Enter a valid character",
    "oamOne": "OAM One-to-One",
    "capsRangeIllegal": "The input value must be between 1 and 20000.",
    "deployAlias": "Alias",
    "editLicense": "Modify License"
  },
  "MCS": {
    "cancel": "Cancel",
    "highUser": "Advanced User",
    "mcsManagement": "MCS Management",
    "userInfo": "Subscriber Information",
    "mod": "Modify",
    "zoomOut": "Zoom Out",
    "del": "Delete",
    "sendingMML": "Sending MML",
    "voiceBusiness": "Voice",
    "ftpUploadFailed": "FTP upload failed.",
    "blackImport": "Blacklist Import",
    "cellNumber": "Cell Number",
    "cover": "Overwrite",
    "startTask": "Starting task",
    "au_vi": "Audio/Video Recording Server",
    "delUser": "Delete",
    "stunKillStatus": "Clear Status",
    "areaName": "Cell Name",
    "enbId": "eNB ID",
    "insertNum": "Enter digits.",
    "programException": "Abnormal program interruption.",
    "taskStatus": "Task Status",
    "groupMemberExport": "Export Group Members",
    "downloadResult": "Download Result",
    "qryGroupList": "Query Group List",
    "zoomIn": "Zoom In",
    "participantType": "Subscriber Type",
    "importSuccess": "Import succeeded",
    "importFailed": "Import failed",
    "importIgnore": "Import ignore",
    "importTotal": "Import total",
    "require": "Cannot be empty.",
    "groupList": "Group List",
    "userPrivilege": "User Privilege",
    "charAt63": "Enter 0–63 characters.",
    "blackListDealType": "Blacklist Process",
    "rangeLat": "Enter longitude within [–180,180].",
    "groupMemberManage": "Group Member Management",
    "cancle": "Cancel",
    "dispatchFail": "Dispatch failed.",
    "registerStatus": "Registration Status",
    "ordinaryUser": "Normal User",
    "taskName": "Task Name",
    "chooseAreaGroup": "Cannot configure call area for a non-area group.",
    "isCover": "Overwrite existing data",
    "charAt1And63": "Enter 1–63 characters.",
    "dataValidationFailed": "Table data verification failed.",
    "partiallyImportSuccess": "Partially succeeded",
    "organizationError": "Organization error.",
    "importingUser": "Importing users",
    "taskEnd": "Task finished",
    "dataBusiness": "Data",
    "waittingResult": "Waiting for results",
    "skip": "Skip",
    "cell": "Cell",
    "userPriority": "User Priority",
    "waitting": "Pending",
    "closeDrawMode": "Close Drawing Mode",
    "addArea": "Add Cell",
    "recieveMML": "Receiving MML",
    "offline": "Offline",
    "vpn0CantAddGroup": "Operation not allowed under root node.",
    "gpsGroupCallManage": "Call Area Management",
    "neOffLine": "The NE is offline.",
    "executionResult": "Execution Result",
    "blackList": "Blacklist",
    "startTime": "Start Time",
    "groupInfo": "Group Information",
    "addGroup": "Add",
    "areaGroup": "Area Group",
    "groupOverSheet": "Exceeded the maximum number of groups per sheet.",
    "excelReadError": "An error occurred while reading excel table.",
    "templateDownload": "Download Template",
    "numAt63": "Enter 0–63 digits.",
    "areaList": "Cell",
    "refresh": "Refresh",
    "updateTime": "Update Time",
    "emerGrpOrEmerUsr": "You can only configure either emergency private number or emergency group number.",
    "addUserManagement": "Subscriber",
    "kill": "Killed",
    "complate": "Done",
    "confirm": "OK",
    "numOrChar": "Enter digits or letters.",
    "areaId": "Cell Index",
    "createTime": "Creation time",
    "resultDetail": "Result Details",
    "openDrawMode": "Open Drawing Mode",
    "chooseNe": "Select NE.",
    "qry": "Query",
    "manageBlackNum": "Blacklist Management",
    "endTime": "Stop Time",
    "organizationImport": "Organization Import",
    "inputLat": "Enter latitude(degree)",
    "taskStep": "Task Step",
    "dc": "DC",
    "batchImportManagement": "Batch Import Management",
    "userGroupMemberImport": "Subscriber, group, and membership",
    "userNum": "Subscriber Number",
    "importingGroupMember": "Importing subscriber-group relation",
    "groupExport": "Export Groups",
    "addUser": "Add",
    "unzipFailed": "An error occurred while decompressing the zip file.",
    "num": "items",
    "stun": "Stunned",
    "importingResult": "Importing result",
    "batchManagement": "Batch Management",
    "noSpecialChar": "Special characters are not allowed.",
    "batchManagementDetail": "Details",
    "export": "Export",
    "cannotaddtocell": "This kind of subscriber type cannot be added to cell.",
    "add": "Add",
    "all": "All",
    "passwordEqual": "Password and confirm password must be the same.",
    "addBlackNum": "Add to Blacklist",
    "groupMemOverSheer": "Exceeded the maximum number of subscriber-group relations  per sheet.",
    "messageInfo": "Log",
    "groupCallImport": "Group Area Info Import",
    "netType": "Network Type",
    "filed": "Failed",
    "egci": "EGCI",
    "groupNum": "Group Number",
    "cellId": "Cell ID",
    "groupAreaDealType": "Group Area Process",
    "addGroupMember": "Add Group Members",
    "nozonegrp": "Cannot configure area group when the area feature is disabled.",
    "addConfirm": "Are you sure you want to add it?",
    "templateNotFound": "Template not found in the database",
    "importingOrgaintion": "Importing organization",
    "rangeLng": "Enter latitude within [–90,90].",
    "checkingData": "Checking Data",
    "modArea": "Modify Cell",
    "groupType": "Group Type",
    "locate": "Locate",
    "vpn0CantAddUser": "Operation not allowed under root node.",
    "userOverSheet": "Exceeded the maximum number of subscribers per sheet.",
    "staticGroup": "Static Group",
    "description": "Description",
    "admin": "Admin",
    "userAuthAreaImport": "Subscriber Cell Info Import",
    "superUser": "Super User",
    "batchImportModify": "Modify",
    "running": "In progress",
    "serviceException": "Service Exception",
    "importType": "Import Type",
    "taskType": "Task Type",
    "onlyData": "Select only one item.",
    "dynamicGroup": "Dynamic Group",
    "groupMember": "Group Member",
    "userAlias": "Alias",
    "groupAlias": "Group Alias",
    "emerGrpAlarmOrEmerUsrAlarm": "You can only configure either one-to-one emergency alert or group emergency alert.",
    "working": "Normal",
    "plmnId": "PLMN",
    "manageAreaNum": "Delete from Cell",
    "process": "Progress",
    "dcWarn": "Cannot set the dispatch number as call forward number.",
    "groupOwner": "Group Owner",
    "addAreaNum": "Add to Cell",
    "importingGroup": "Importing groups",
    "allImportFailed": "Import failed.",
    "videoBusiness": "Video",
    "mobile": "Mobile Radio",
    "vpn0CantAddUsOrMo": "Operation not allowed under root node.",
    "deleteConfirm": "Are you sure you want to delete it?",
    "modGroup": "Modify",
    "cellImport": "Cell Import",
    "groupCall": "Call Area",
    "timeOut": "Timeout",
    "notAllowedChinese": "Chinese characters not allowed",
    "charAt6And63": "Enter 6–63 characters.",
    "getResponseFailed": "Failed to get response.",
    "inputLng": "Enter longitude(degree)",
    "charAt254": "Enter 0–254 characters.",
    "chooseData": "Select data.",
    "modUser": "Modify",
    "online": "Online",
    "superSearch": "Advanced Search",
    "choosed": "You have selected",
    "groupMemberDealType": "Group Member Process",
    "user": "SIP Terminal",
    "menuTitleAreaMcs": "Subscriber/MCS Management/Cell Management",
    "append": "Add"
  },
  "Topo": {
    "devType": "Device Type",
    "cancel": "Cancel",
    "modifySuccess": "Modified successfully.",
    "nePGW": "PGW",
    "neModify": "Modify NE",
    "showTips": "Show Info",
    "devAttriTrunk": "Home Cluster",
    "bStation": "Device Management",
    "devAdd": "Add Device",
    "addTrunk": "Add Cluster",
    "trunkSelect": "Select the cluster type first.",
    "deviBS": "iBS",
    "memoryUse": "Memory Usage",
    "fullScreen": "Full Screen",
    "devMange": "Device Management",
    "trunkManager": "Cluster Management",
    "serviceContainer": "Service Container",
    "trunkAdd": "Add Cluster",
    "sureDel": "Are you sure you want to delete it?",
    "delDeviceMessage": "This operation will delete all information of the network element EnodeB. After deletion, please add it again if necessary.",
    "devID": "Device ID",
    "neDBS": "DBS",
    "restartCount": "Total Reboots",
    "latitude": "Latitude",
    "ne5gDU": "5G-DU",
    "nelementMana": "EPC Management",
    "forbidDel": "This IP and port cannot be deleted.",
    "neMC_PF": "MC_PF",
    "devgNB": "GNB",
    "addSuccess": "Added successfully.",
    "deleteSubnet": "Delete Subnet",
    "search": "Search",
    "topoManagerAndTopoMonitor": "Topology/Topology Monitor",
    "pleaseEnterNeName": "Enter the NE name.",
    "devSoftVersion": "Software Version",
    "bakSoftVersion": "Backup Software Version",
    "hiddenTips": "Hidden Info",
    "neCU": "CU",
    "noAddMore": "Cannot add any more.",
    "trunkName": "Cluster Name",
    "neBM_SC": "BM-SC",
    "servicePOD": "Service POD",
    "neMCE": "MCE",
    "deviBSB": "iBS-B",
    "cpuRatio": "CPU Usage",
    "longitudePlaceholder": "Enter the longitude between –180 and 180.",
    "refresh": "The topology structure has changed and the page will be refreshed.",
    "delDev": "Delete Device",
    "delNeFailedForRealTaskMsg": "Delete failed, please delete real time tasks under this NE {0} first",
    "noSelectTrunk": "Cannot select home cluster for this type of device.",
    "confirm": "OK",
    "subnetFilterPlaceHolder": "Node Type/Node Name",
    "devDescription": "Device Description",
    "trunkHyTalk": "HyTalk",
    "updateSubnet": "Modify Subnet",
    "subnetType": "Subnet Type",
    "mountNode": "Mount Node",
    "addDev": "Add Device",
    "topoRack": "Rack Diagram",
    "trunkId": "Trunk ID",
    "nePCDR": "PCDR",
    "elementTree": "NE Tree",
    "delNe": "Delete NE",
    "cmdline": "CMD Line",
    "runningStatus": "Running status",
    "devhytalk": "HyTalk",
    "neTCF": "TCF",
    "SubnetAtLeastTwoNodes": "At least two nodes or a subnet in a subnet",
    "saveTopo": "Save Topology",
    "neMC_GMS": "MC_GMS",
    "topoMonitorPhysicalGraph": "Physical View",
    "devEPC": "EPC Server",
    "parentNode": "Parent Node",
    "devName": "Device Name",
    "nodeType": "Node Type",
    "revertScale": "Restore View",
    "subnetNumFour": "The subnet consists of at most 4 levels.",
    "selectAll": "Select All",
    "altitudeIllegal": "The input value must be between –9999 and 9999.",
    "success": "Succeeded",
    "invalidInt": "Invalid integer.",
    "name": "Name",
    "neDU": "DU",
    "nodeId": "Node ID",
    "permissionDenied": "Permission denied.",
    "inputRangeIllegal": "The input value must be between 1 and 65535.",
    "devPort": "Communication Port",
    "editDev": "Modify Device",
    "serviceId": "Service ID",
    "trunkNelist": "Mount NE",
    "serveDetail": "Service Details",
    "devBelongSubnet": "Home Subnet",
    "neDev": "Home Device",
    "ipIllegal": "Enter a valid IP.",
    "devCrumb": "Topology/Resource Management/Device Management",
    "equipmentList": "Device List",
    "service": "Service",
    "devAttriSelect": "Select the home device first",
    "nePCRF": "PCRF",
    "emap": "Topology/Electronic Map",
    "deveNodeB": "eNodeB",
    "devegNodeB":"gNodeB",
    "subnetMan": "Subnet Management",
    "pleaseSelect": "Select an item.",
    "ipPortDup": "Duplicate IP and port.",
    "noData": "No data",
    "topoLoad": "Loading...",
    "neType": "NE Type",
    "pleaseEnterDeviceName": "Enter the device name.",
    "neODBBU": "ODBBU",
    "devhytalkPro": "HyTalk Pro",
    "nePRES": "PRES",
    "neTypeForSubnet": "NE Type",
    "id": "ID",
    "neID": "NE ID",
    "devMCS": "MCS Server",
    "memoryUsage": "Memory Usage",
    "ip": "IP",
    "topoMonitorLogicalGraph": "Logical View",
    "noAttriTrunk": "It does not belong to any cluster.",
    "deveNodeBIOPS": "eNodeB-IOPS",
    "devIpPort": "Communication IP and Port",
    "noEmptyStart": "Names must not start with a space.",
    "subnetDes": "Subnet Description",
    "neP_HSS": "P_HSS",
    "netTypeImg": "NE Legend",
    "neMC_GMS_NODE": "MC_GMS_NODE",
    "status": "Clear Status",
    "nodeName": "Node Name",
    "topoMaxLength": "Text length cannot exceed",
    "devAttriSubnet": "Select home subnet",
    "neiBS_B": "iBS-B",
    "addSubnet": "Add Subnet",
    "devModify": "Modify Device",
    "memRatio": "Memory Usage",
    "neSGW": "SGW",
    "neAdd": "Add NE",
    "neMC_IDMS": "MC_IDMS",
    "devSelect": "Select device type first",
    "deviceUpdate": "Device Update",
    "backPrevious": "Back",
    "neSelect": "Select NE type first.",
    "editNe": "Modify NE",
    "topoRerefresh": "Refresh",
    "childNode": "Child Node",
    "pleaseSelectOne": "Select an item.",
    "latitudePlaceholder": "Enter a value between –90 and 90",
    "altitudePlaceholder": "Enter a value between –9999 and 9999",
    "cummunicateIPPort": "Communication IP and Port",
    "cpuUsage": "CPU Usage",
    "emptySubnet": "Cannot create an empty subnet.",
    "dockerContainerId": "Container Name",
    "delTrunk": "Delete Cluster",
    "devThread": "Process ID",
    "neName": "NE Name",
    "deviceReback": "Device Rollback",
    "processName": "Process Name",
    "containerName": "Container Name",
    "excelLayout": "Table Layout",
    "bStationEdition": "Device Version Management",
    "patchVersion": "Patch Version",
    "patchVersionUpgrade": "Patch Management",
    "devicePatchRollback":" Patch Rollback",
    "neList": "NE List",
    "topoManager": "Topology",
    "longitude": "Longitude",
    "neMBMS_GW": "MBMS-GW",
    "longitudeIllegal": "The input value must be between –180 and 180.",
    "devManager": "Device Management",
    "ne5gCU": "5G-CU",
    "neMC_KMS": "MC_KMS",
    "servicePID": "Service PID",
    "neCrumb": "Topology/Resource Management/NE Management",
    "physicalIP": "Physical IP",
    "invalidIPAddress": "Invalid IP address. For example, 192.168.69.1",
    "neHSS": "HSS",
    "devIp": "Communication IP",
    "neMC_CMS": "MC_CMS",
    "neMME": "MME",
    "trunkCrumb": "Topology/Resource Management/Cluster Management",
    "devODBBU": "ODBBU",
    "neManager": "NE Management",
    "nePDTGW": "PDTGW",
    "podName": "POD name",
    "neDevSelect": "Select the home cluster first.",
    "addNe": "Add NE",
    "altitude": "Altitude(m)",
    "trunkModify": "Modify Cluster",
    "latitudeIllegal": "The input value must be between –90 and 90.",
    "neDescription": "NE Description",
    "error": "Failed",
    "neFRS": "FRS",
    "portIllegal": "The range is 1024–65535.",
    "subnetName": "Subnet Name",
    "envirommentName": "Cluster Name",
    "nameSpace": "Namespace",
    "ok": "OK",
    "subnetID": "Subnet ID",
    "editTrunk": "Modify Cluster",
    "neMC_TMF": "MC_TMF",
    "delSuccess": "Deleted successfully.",
    "topoSearchEquipment": "Search Device",
    "neTMF": "TMF",
    "serviceName": "Service Name",
    "neDMS": "DMS",
    "physicalPort": "Physical Port",
    "neMange": "NE Management",
    "trunkMC_CF": "MCS",
    "neMC_CF": "MC_CF",
    "trunkCode": "Cluster Type",
    "neeNodeB": "eNodeB",
    "trunkMange": "Cluster Management",
    "trunkDescription": "Cluster Description",
    "pmTaskExist": "This EnodeB has performance task and cannot be deleted",
  },
  "Track": {
    "filterConditions": "Filter Conditions",
    "struct": "Structure",
    "cancel": "Cancel",
    "neId": "NE ID",
    "fileName": "File Name",
    "maximumMissionNumber": "At most 5 task tracking",
    "taskDeletion": "Delete Task",
    "signManage": "Signaling",
    "resourcesList": "Resource List",
    "publicMessage": "Public Message",
    "taskTracking": "Task Tracking",
    "messageType": "Message Type",
    "realTimeFiltering": "Real-time Filter",
    "text": "Text",
    "issued": "To be issued",
    "taskID": "Task ID",
    "taskStatus": "Task Status",
    "suspendTask": "Suspend Task",
    "active": "Execute",
    "realTime": "Real-time",
    "downloadFile": "Download File",
    "mission": "Track",
    "stop": "Pause",
    "taskName": "Task Name",
    "detail": "Details",
    "queryTrack": "Query Signaling",
    "createTask": "Create Task",
    "status": "Clear Status",
    "taskSrc": "Task Source",
    "greate": "Pending",
    "autoActivationFailed": "Auto activation failed.",
    "save": "Save",
    "taskList": "Task List",
    "refreshTask": "Refresh Task",
    "addTask": "Add Task",
    "result": "Result",
    "search": "Search",
    "file": "File",
    "creatTime": "Creation time",
    "pleaseSelectNE": "Select the resource.",
    "pleaseSelectEffect": "Please select the pending or hangup or to be issued status for operations",
    "noDataToExport": "No data found.",
    "taskIsPending": "The task is suspended.",
    "startTime": "Start time",
    "operating": "Operation",
    "endTimeGreaterThanStartTime": "The end time should be later than the start time.",
    "close": "Close",
    "historyFilter": "History Filtering",
    "resourceID": "Resource ID",
    "systemId": "System ID",
    "expression": "Expression",
    "activationTask": "Activate Task",
    "filter": "Filter",
    "confirm": "OK",
    "taskTypeID": "Template ID",
    "downloadExcel": "Download Excel",
    "endTime": "Stop Time",
    "complete": "Finished",
    "resourceType": "Resource Type",
    "searchNe": "Search NE",
    "reIssued": "Re-issue",
    "neName": "NE Name",
    "trackingCommunity": "Tracking Area",
    "hangup": "Suspend",
    "pleaseEnterQuery": "Enter the query criteria.",
    "reportType": "Report Type",
    "download": "Download",
    "finish": "Done",
    "export": "Export",
    "taskDetails": "Task details",
    "importTrackData": "Import Signaling Data",
    "all": "All",
    "add": "Add",
    "signalingDetails": "Signaling Details",
    "tracing": "Running",
    "attributeValues": "Attribute Value",
    "resourceName": "Resource Name",
    "queryError": "Query error.",
    "notGenerated": "Files not generated.",
    "updateTask": "Edit Task",
    "importFileError": "The imported file is incorrect.",
    "deleteTaskInfo": "Deleting a task will also delete the related report file. Do you want to delete the task？",
    "success": "Succeeded",
    "monitorTrack": "Task Monitor",
    "standardInterface": "Standard Interface",
    "activation": "Activate",
    "missionAlreadyCompleted": "Task completed.",
    "import": "Import",
    "taskInProgress": "Task in progress",
    "measuringObject": "Measurement Object",
    "signTrack": "Signaling Trace",
    "NElist": "NE List",
    "error": "Failed",
    "delete": "Delete",
    "pleaseSelectMeasuringObject": "Select the measuring object.",
    "attributeName": "Attribute Name",
    "signalDataExport": "Export Signaling Data",
    "userTrack": "User Tracking",
    "missionCompleted": "Finish Task",
    "deleteFile": "Do you want to delete the file？",
    "searchResource": "Search resource",
    "implementation": "In progress",
    "fieldIsRequired": "This item cannot be empty.",
    "pleaseEnterQueryName": "Enter the task name.",
    "systemOutTime": "System connection timed out",
    "pleaseSelect": "Select",
    "time": "Time",
    "internalSignaling": "Internal Signaling",
    collapseAllNodes: 'Collapse All',
    expandAllNodes: 'Expand All',
    invalidFile: 'Invalid file format.',
  },
  "TS": {
    "callSetUpTimeCount": "Call Count by Setup Time",
    "singleCallSetUpTime": "Call Count by Setup Time for Selected Interval",
    "ts_ok": "OK",
    "time1day": "1 day",
    "ts_chart_firstNumber_bigerthan0": "The digits must be greater than 0.",
    "startDateNoEqualsEndDate": "The start date and end date cannot be the same.",
    "ts__task_name_userCount": "Subscriber Count Collection",
    "starttime": "Start Date",
    "ts_cancell": "Cancel",
    "taskState": "Task State",
    "sendTimeHeader": "Send Time",
    "registerStatusHeader": "Registration Status",
    "emergencyCallStatus_0": "Non-emergency Call",
    "emergencyCallStatus_1": "Emergency Call",
    "ts_cannot_operate": "Operation not allowed",
    "configTimeRange": "Call Setup Time Range Boundaries",
    "ts_neOffLine": "NE Offline.",
    "neID": "NE ID",
    "statisticsTime": "Statistics Time",
    "timeDay": "day",
    "ts_back_must_larger_than_pre": "The latter value must be greater than the previous value.",
    "ts_call_isCaller": "Call Flag",
    "ts_fail": "Operation failed.",
    "onlineUsereStatistics": "Active Subscribers",
    "registerTime": "Operation Time",
    "ts_call_beginTime": "Call Initiation Time",
    "onlineUserRegisterCount": "Total Registration",
    "callingTypeStatus_7": "Mobile Radio",
    "callingTypeStatus_8": "ULP",
    "registerAddress": "Operation Address",
    "callingTypeStatus_9": "Group Number",
    "ts_xAxis": "X-Axis",
    "registerStatus_0": "Deregistration",
    "registerStatus_1": "Registration",
    "operateResult": "Operation Result",
    "ts_call_audioCode": "Codec",
    "callingTypeStatus_0": "Unknown",
    "callingTypeStatus_1": "SIP Terminal",
    "taskName": "Task Name",
    "interval": "Interval",
    "callingTypeStatus_2": "Dual-mode Terminal",
    "callingTypeStatus_3": "Audio/Video Recording Server",
    "registerStatus_2": "Registration failed.",
    "ts_call_callType": "Call Type",
    "callingTypeStatus_4": "PNAS Terminal",
    "registerStatus_3": "Periodic Registration",
    "callingTypeStatus_5": "DC",
    "ts_call_callingAddress": "Caller Number",
    "callingTypeStatus_6": "Dispatcher",
    "numHeader": "Number",
    "gs_search": "Advanced Search",
    "ts_call_setup_time": "Call Setup Time(ms)",
    "dailyActivityCount": "Daily Active Subscribers",
    "callCauseStatus_1": "Succeeded",
    "callCauseStatus_0": "Failed",
    "ts__task_name_data": "Data Task",
    "searchByNumHolder": "Enter the number",
    "callCount": "Total Calls",
    "ts_chart_illegal_number": "Enter digits",
    "time1hour": "1 hour",
    "ts_digital_callType": "Message Type",
    "ts_call_callingType": "Caller Type",
    "ts__task_name_onlineTime": "Online Time Collection",
    "taskDetail": "Task Description",
    "ts_chart_single_video": "Video Private Call",
    "ts_xAxis_time": "Time",
    "ts_call_e2EE": "Encryption Flag",
    "calledAddressHeader": "Callee Number",
    "callTypeHeader": "Type",
    "timeShowHour": "h",
    "operating": "Operation",
    "alertMessage": "Alert",
    "e2EEStatus_0": "Unencrypted",
    "e2EEStatus_1": "E2EE",
    "onlineTimeStatistics": "Online Time",
    "startDateEqualsEndDate": "The start date and end date must be the same.",
    "ts_call_callFailReason": "Cause of Failure",
    "endtime": "End Date",
    "ts_call_callingTotalTime": "Call Total Time(s)",
    "ts_task_oper_stop": "Pause",
    "ts_digital_callCause": "Cause of Failure",
    "correctFormat": "Enter at most 50 numbers.",
    "ts_callee_detail": "Callee Details",
    "msgCountStatistics": "Message Statistics",
    "ts__task_name_reg": "Registration Collection",
    "duplexModeStatus_0": "Non-full-duplex Call",
    "registerCountStatistics": "Registration Statistics",
    "duplexModeStatus_1": "Full-duplex Call",
    "startDateGreaterEndDate": "The start date cannot be later than end date.",
    "callFailedCount": "Failed Calls",
    "ts_information_reporting_reg": "Report Registration Information",
    "ts_call_groupNum": "Group Number",
    "neIDIsNull": "Select an NE.",
    "ts_call_startTime": "Call Average Setup Time",
    "ts_count": "Count",
    "ts_have_stop_task": "Task is already stopped.",
    "ts_chart_xAxis_positive_integer": "Enter a positive integer.",
    "operation": "Operation",
    "ts_call_duplexMode": "Is full-duplex",
    "ts_call_endTime": "Call End Time",
    "ts_information_reporting_call": "Report Call Information",
    "singleCallFailedCount": "Failed Calls for Selected Interval",
    "acceptTimeHeader": "Accept Time",
    "neName": "NE Name",
    "time15min": "15 min",
    "unReg_1": "System",
    "unReg_0": "UE",
    "ts_chart_atleast_two_numbers": "Enter at least 2 digits.",
    "operateResult_1": "Succeeded",
    "operateResult_0": "Failed",
    "datetime": "Date",
    "callFailureCountStatistics": "Failed Calls",
    "unReg": "Initiator",
    "ts_call_emergencyCall": "Emergency Call Flag",
    "ts_call_type": "Call Type",
    "timeMonth": "month",
    "userNumber": "Subscriber Number",
    "configTime": "Call Setup Time Range",
    "onlineUserAllCount": "Total Subscribers",
    "timeShowMin": "m",
    "ts_chart_group_call": "Voice Group Call",
    "sendResult": "Send Result",
    "ts_task_oper_start": "Start",
    "dailyActivityStatistics": "Daily Active Statistics",
    "ts_number_not_null": "The inputs must be consecutive.",
    "callingAddressHeader": "Caller Number",
    "callCountStatistics": "Call Count",
    "ts_information_reporting_userCount": "Report Subscriber Count",
    "ts_chart_single_call": "Voice Private Call",
    "ts_neList": "NE List",
    "callServiceStatistics": "Call Statistics",
    "success": "Succeeded",
    "ts_digital_isCaller": "Message Flag",
    "ts_information_reporting_onlineTime": "Report Online Time Information",
    "trafficTaskManagement": "Task management",
    "registerServiceStatistics": "Registration Statistics",
    "taskState_0": "Pause",
    "terminalType_9": "Group Number",
    "taskState_1": "Execute",
    "ts_information_reporting_data": "Report Data Information",
    "terminalType_4": "PNAS Terminal",
    "terminalType_3": "Audio/Video Recording Server",
    "terminalType_2": "Dual-mode Terminal",
    "terminalType_1": "SIP Terminal",
    "terminalType_8": "ULP",
    "startDateMaxEndDate": "The interval must be within 31 days.",
    "terminalType_7": "Mobile Radio",
    "terminalType_6": "Dispatcher",
    "ts_call_detail": "Details",
    "digitalServiceStatistics": "Data Statistics",
    "terminalType_5": "DC",
    "msgCallType_4": "Group Multimedia Message",
    "dataLenHeader": "Date Length(byte)",
    "onlineTime": "Online Time",
    "msgCallType_5": "Broadcast Message",
    "msgCallType_2": "Group Message",
    "msgCallType_3": "Point-to-point Multimedia Message",
    "terminalType_0": "Unknown",
    "msgTypeDetailTitle": "Data Statistics Details",
    "ts_call_callCause": "Call Result",
    "msgCallType_1": "Point-to-point Message",
    "searchByCallerHolder": "Enter the call number",
    "ts_chart_broadcast_call": "Broadcast Call",
    "ts_chart_group_video": "Video Group Call",
    "trafficMeasurement": "Statistics",
    "ts_call_calledType": "Callee Type",
    "callSetUpTimeStatistics": "Call Average Setup Time",
    "ts_register_callCause": "Cause of Failure",
    "selectNeIDIsNull": "Select the NE in the search box first.",
    "startDateIsNull": "The start date cannot be empty.",
    "endDateIsNull": "The end date cannot be empty.",
    "ts_call_calledAddress": "Callee Number",
    "isCallerStatus_0": "Callee",
    "ts_call_priority": "Call Priority",
    "isCallerStatus_1": "Caller",
    "ts__task_name_call": "Call Collection",
    "opTime": "Operation Time",
    "ts_have_start_task": "Task is already started.",
    "ts_average_time": "Average Setup Time(ms)",
    "terminalTypeHeader": "Terminal Type",
    "ts_search": "Search",
    "registerTypeDetailTitle": "Registration Statistics Details"
  },
  "ErrorCode": {
    "16001": "The CM service has been stopped, so the PM service cannot be stopped",
    "16002": "The CM service has been stopped, so the PM service cannot be started",
    "16003": "The CM service has been stopped, configuration related operations cannot be performed",
    "16004": "Only one user can perform a backup at a time, please perform backup later...",
    "16005": "The task is executing, please try later...",
  }
};
